var _defs, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15, _g16, _g17, _g18, _g19, _g20, _g21, _g22, _g23, _g24, _g25, _g26, _g27, _g28, _g29, _g30, _g31, _g32, _g33, _g34, _g35, _g36, _g37, _g38, _g39, _g40, _g41, _g42, _g43, _g44, _g45, _g46, _g47, _g48, _g49, _g50, _g51, _g52, _g53, _g54, _g55, _g56, _g57, _g58, _g59, _g60, _g61, _g62, _g63, _g64, _g65, _g66, _g67, _g68, _g69, _g70, _g71, _g72, _g73, _g74, _g75, _g76, _g77, _g78, _g79, _g80, _g81, _g82, _g83, _g84, _g85, _g86, _g87, _g88, _g89, _g90, _g91, _g92, _g93, _g94, _g95, _g96, _g97, _g98, _g99, _g100, _g101, _g102, _g103, _g104, _g105, _g106, _g107, _g108, _g109, _g110, _g111, _g112, _g113, _g114, _g115, _g116, _g117, _g118, _g119, _g120, _g121, _g122, _g123, _g124, _g125, _g126, _g127, _g128, _g129, _g130, _g131, _g132, _g133, _g134, _g135, _g136, _g137, _g138, _g139, _g140, _g141, _g142, _g143, _g144, _g145, _g146, _g147, _g148, _g149, _g150, _g151, _g152, _g153, _g154, _g155, _g156, _g157, _g158, _g159, _g160, _g161, _g162, _g163, _g164, _g165, _g166, _g167, _g168, _g169, _g170, _g171, _g172, _g173, _g174, _g175, _g176, _g177, _g178, _g179, _g180, _g181, _g182, _g183, _g184, _g185, _g186, _g187, _g188, _g189, _g190, _g191, _g192, _g193, _g194, _g195, _g196, _g197, _g198, _g199, _g200, _g201, _g202, _g203, _g204, _g205, _g206, _g207, _g208, _g209, _g210, _g211, _g212, _g213, _g214, _g215, _g216, _g217, _g218, _g219, _g220, _g221, _g222, _g223, _g224, _g225, _g226, _g227, _g228, _g229, _g230, _g231, _g232, _g233, _g234;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgServiceSvg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 800 800",
    width: 800,
    height: 800,
    preserveAspectRatio: "xMidYMid meet",
    style: {
      width: "100%",
      height: "100%",
      transform: "translate3d(0px, 0px, 0px)",
      contentVisibility: "visible"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "__lottie_element_2"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 800,
    height: 800,
    x: 0,
    y: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "__lottie_element_4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L800,0 L800,800 L0,800z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "__lottie_element_32"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L800,0 L800,800 L0,800z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "__lottie_element_39"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L800,0 L800,800 L0,800z"
  })))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#__lottie_element_2)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#__lottie_element_39)",
    transform: "matrix(1,0,0,1,0,0)",
    opacity: 1,
    style: {
      display: "block"
    }
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,400,400)",
    opacity: 1,
    style: {
      display: "block"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    fillOpacity: 0,
    strokeMiterlimit: 4,
    stroke: "rgb(49,117,209)",
    strokeOpacity: 1,
    strokeWidth: 2,
    d: " M154.8869171142578,-299.74090576171875 C154.8869171142578,-299.74090576171875 120.909423828125,-222.87045288085938 120.909423828125,-222.87045288085938"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,400,400)",
    opacity: 1,
    style: {
      display: "block"
    }
  }, _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    fillOpacity: 0,
    strokeMiterlimit: 4,
    stroke: "rgb(49,117,209)",
    strokeOpacity: 1,
    strokeWidth: 2,
    d: " M-36.944454193115234,-336.6719665527344 C-36.944454193115234,-336.6719665527344 -0.125,-312.125 -0.125,-312.125"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    fillOpacity: 0,
    strokeMiterlimit: 4,
    stroke: "rgb(49,117,209)",
    strokeOpacity: 1,
    strokeWidth: 2,
    d: " M120.72050476074219,-222.99545288085938 C120.72050476074219,-222.99545288085938 0.375,-312.125 0.375,-312.125"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    fillOpacity: 0,
    strokeMiterlimit: 4,
    stroke: "rgb(49,117,209)",
    strokeOpacity: 1,
    strokeWidth: 2,
    d: " M154.947998046875,-299.49090576171875 C154.947998046875,-299.49090576171875 0,-312.31201171875 0,-312.31201171875"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,400,400)",
    opacity: 1,
    style: {
      display: "block"
    }
  }, _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    fillOpacity: 0,
    strokeMiterlimit: 4,
    stroke: "rgb(49,117,209)",
    strokeOpacity: 1,
    strokeWidth: 2,
    d: " M120.659423828125,-222.55653381347656 C120.659423828125,-222.55653381347656 47.68536376953125,-79.9502182006836 47.68536376953125,-79.9502182006836"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,400,400)",
    opacity: 1,
    style: {
      display: "block"
    }
  }, _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    fillOpacity: 0,
    strokeMiterlimit: 4,
    stroke: "rgb(49,117,209)",
    strokeOpacity: 1,
    strokeWidth: 2,
    d: " M0.5,-313.5 C0.5,-313.5 -65.95556640625,-209.66836547851562 -65.95556640625,-209.66836547851562 C-65.95556640625,-209.66836547851562 120.659423828125,-222.30653381347656 120.659423828125,-222.30653381347656"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,400,400)",
    opacity: 1,
    style: {
      display: "block"
    }
  }, _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    fillOpacity: 0,
    strokeMiterlimit: 4,
    stroke: "rgb(49,117,209)",
    strokeOpacity: 1,
    strokeWidth: 2,
    d: " M-64.33802032470703,-253.4886932373047 C-64.33802032470703,-253.4886932373047 3.5,-219.5 3.5,-219.5 C3.5,-219.5 272.1742858886719,-193.15830993652344 272.1742858886719,-193.15830993652344"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,400,400)",
    opacity: 1,
    style: {
      display: "block"
    }
  }, _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    opacity: 0,
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    fillOpacity: 0,
    strokeMiterlimit: 4,
    stroke: "rgb(49,117,209)",
    strokeOpacity: 1,
    strokeWidth: 2,
    d: " M-234,-233 C-234,-233 -175,-268.5 -175,-268.5"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    opacity: 0,
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    fillOpacity: 0,
    strokeMiterlimit: 4,
    stroke: "rgb(49,117,209)",
    strokeOpacity: 1,
    strokeWidth: 2,
    d: " M-53.5,-335.75 C-53.5,-335.75 -175.125,-268.125 -175.125,-268.125"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    fillOpacity: 0,
    strokeMiterlimit: 4,
    stroke: "rgb(49,117,209)",
    strokeOpacity: 1,
    strokeWidth: 2,
    d: " M1,-312 C1,-312 -172.68797302246094,-274.5488586425781 -172.68797302246094,-274.5488586425781"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    fillOpacity: 0,
    strokeMiterlimit: 4,
    stroke: "rgb(49,117,209)",
    strokeOpacity: 1,
    strokeWidth: 2,
    d: " M-64.98493957519531,-209.14231872558594 C-64.98493957519531,-209.14231872558594 -172.68797302246094,-274.0488586425781 -172.68797302246094,-274.0488586425781"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,400,400)",
    opacity: 1,
    style: {
      display: "block"
    }
  }, _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    fillOpacity: 0,
    strokeMiterlimit: 4,
    stroke: "rgb(49,117,209)",
    strokeOpacity: 1,
    strokeWidth: 2,
    d: " M272.679931640625,-193.78048706054688 C272.679931640625,-193.78048706054688 274.77484130859375,-153.91397094726562 274.77484130859375,-153.91397094726562"
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    fillOpacity: 0,
    strokeMiterlimit: 4,
    stroke: "rgb(49,117,209)",
    strokeOpacity: 1,
    strokeWidth: 2,
    d: " M154.89822387695312,-299.9852600097656 C154.89822387695312,-299.9852600097656 273.77484130859375,-154.91397094726562 273.77484130859375,-154.91397094726562"
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    fillOpacity: 0,
    strokeMiterlimit: 4,
    stroke: "rgb(49,117,209)",
    strokeOpacity: 1,
    strokeWidth: 2,
    d: " M120.47050476074219,-222.1787109375 C120.47050476074219,-222.1787109375 273.77484130859375,-153.41397094726562 273.77484130859375,-153.41397094726562"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,400,400)",
    opacity: 1,
    style: {
      display: "block"
    }
  }, _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    fillOpacity: 0,
    strokeMiterlimit: 4,
    stroke: "rgb(49,117,209)",
    strokeOpacity: 1,
    strokeWidth: 2,
    d: " M3.5,-220.5 C3.5,-220.5 200.68516540527344,-77.60177612304688 200.68516540527344,-77.60177612304688"
  }))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    opacity: 0,
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    fillOpacity: 0,
    strokeMiterlimit: 4,
    stroke: "rgb(49,117,209)",
    strokeOpacity: 1,
    strokeWidth: 2,
    d: " M339.25,-22.25 C339.25,-22.25 293,-131.75 293,-131.75"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    fillOpacity: 0,
    strokeMiterlimit: 4,
    stroke: "rgb(49,117,209)",
    strokeOpacity: 1,
    strokeWidth: 2,
    d: " M339.25,-22.25 C339.25,-22.25 293,-131.75 293,-131.75"
  }))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    fillOpacity: 0,
    strokeMiterlimit: 4,
    stroke: "rgb(49,117,209)",
    strokeOpacity: 1,
    strokeWidth: 2,
    d: " M274.65264892578125,-154.2917938232422 C274.65264892578125,-154.2917938232422 200.6231689453125,-79.60177612304688 200.6231689453125,-79.60177612304688"
  }))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    fillOpacity: 0,
    strokeMiterlimit: 4,
    stroke: "rgb(49,117,209)",
    strokeOpacity: 1,
    strokeWidth: 2,
    d: " M120.72616577148438,-223.30653381347656 C120.72616577148438,-223.30653381347656 201.56117248535156,-77.85177612304688 201.56117248535156,-77.85177612304688"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,400,400)",
    opacity: 1,
    style: {
      display: "block"
    }
  }, _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    fillOpacity: 0,
    strokeMiterlimit: 4,
    stroke: "rgb(49,117,209)",
    strokeOpacity: 1,
    strokeWidth: 2,
    d: " M-65.87339782714844,-208.0543212890625 C-65.87339782714844,-208.0543212890625 47.441017150878906,-79.26696014404297 47.441017150878906,-79.26696014404297"
  }))), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    fillOpacity: 0,
    strokeMiterlimit: 4,
    stroke: "rgb(49,117,209)",
    strokeOpacity: 1,
    strokeWidth: 2,
    d: " M200.25099182128906,-78.34611511230469 C200.25099182128906,-78.34611511230469 48.941017150878906,-79.26696014404297 48.941017150878906,-79.26696014404297"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,400,400)",
    opacity: 1,
    style: {
      display: "block"
    }
  }, _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    fillOpacity: 0,
    strokeMiterlimit: 4,
    stroke: "rgb(49,117,209)",
    strokeOpacity: 1,
    strokeWidth: 2,
    d: " M3.5,-219 C3.5,-219 -111.676513671875,-59.6379280090332 -111.676513671875,-59.6379280090332"
  }))), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    fillOpacity: 0,
    strokeMiterlimit: 4,
    stroke: "rgb(49,117,209)",
    strokeOpacity: 1,
    strokeWidth: 2,
    d: " M-65.55665588378906,-209.25454711914062 C-65.55665588378906,-209.25454711914062 -111.64551544189453,-59.54393005371094 -111.64551544189453,-59.54393005371094"
  }))), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    fillOpacity: 0,
    strokeMiterlimit: 4,
    stroke: "rgb(49,117,209)",
    strokeOpacity: 1,
    strokeWidth: 2,
    d: " M48.568843841552734,-80.32804870605469 C48.568843841552734,-80.32804870605469 -111.64551544189453,-59.606929779052734 -111.64551544189453,-59.606929779052734"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,400,400)",
    opacity: 1,
    style: {
      display: "block"
    }
  }, _g24 || (_g24 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    fillOpacity: 0,
    strokeMiterlimit: 4,
    stroke: "rgb(49,117,209)",
    strokeOpacity: 1,
    strokeWidth: 2,
    d: " M-179.32106018066406,-95.54301452636719 C-179.32106018066406,-95.54301452636719 3.25,-62.5 3.25,-62.5"
  }))), _g25 || (_g25 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    fillOpacity: 0,
    strokeMiterlimit: 4,
    stroke: "rgb(49,117,209)",
    strokeOpacity: 1,
    strokeWidth: 2,
    d: " M249.50465393066406,-76.75787353515625 C249.50465393066406,-76.75787353515625 3.5,-63.5 3.5,-63.5"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,400,400)",
    opacity: 1,
    style: {
      display: "block"
    }
  }, _g26 || (_g26 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    fillOpacity: 0,
    strokeMiterlimit: 4,
    stroke: "rgb(49,117,209)",
    strokeOpacity: 1,
    strokeWidth: 2,
    d: " M-110.70377349853516,-60.04301452636719 C-110.70377349853516,-60.04301452636719 -228.0181884765625,-120.9864730834961 -228.0181884765625,-120.9864730834961"
  }))), _g27 || (_g27 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    fillOpacity: 0,
    strokeMiterlimit: 4,
    stroke: "rgb(49,117,209)",
    strokeOpacity: 1,
    strokeWidth: 2,
    d: " M-172.42306518554688,-273.4977722167969 C-172.42306518554688,-273.4977722167969 -228.5181884765625,-119.9864730834961 -228.5181884765625,-119.9864730834961"
  }))), _g28 || (_g28 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    fillOpacity: 0,
    strokeMiterlimit: 4,
    stroke: "rgb(49,117,209)",
    strokeOpacity: 1,
    strokeWidth: 2,
    d: " M-66.88470458984375,-209.5656280517578 C-66.88470458984375,-209.5656280517578 -229.5181884765625,-120.4864730834961 -229.5181884765625,-120.4864730834961"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,400,400)",
    opacity: 1,
    style: {
      display: "block"
    }
  }, _g29 || (_g29 = /*#__PURE__*/React.createElement("g", {
    opacity: 0,
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    fillOpacity: 0,
    strokeMiterlimit: 4,
    stroke: "rgb(49,117,209)",
    strokeOpacity: 1,
    strokeWidth: 2,
    d: " M-252,-221.5 C-252,-221.5 -296.7831726074219,-154.32395935058594 -296.7831726074219,-154.32395935058594"
  }))), _g30 || (_g30 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    fillOpacity: 0,
    strokeMiterlimit: 4,
    stroke: "rgb(49,117,209)",
    strokeOpacity: 1,
    strokeWidth: 2,
    d: " M-231.80099487304688,-120.60713195800781 C-231.80099487304688,-120.60713195800781 -297.2831726074219,-153.32395935058594 -297.2831726074219,-153.32395935058594"
  }))), _g31 || (_g31 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    fillOpacity: 0,
    strokeMiterlimit: 4,
    stroke: "rgb(49,117,209)",
    strokeOpacity: 1,
    strokeWidth: 2,
    d: " M-171.8265380859375,-274.56378173828125 C-171.8265380859375,-274.56378173828125 -297.2831726074219,-154.32395935058594 -297.2831726074219,-154.32395935058594"
  }))), _g32 || (_g32 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    fillOpacity: 0,
    strokeMiterlimit: 4,
    stroke: "rgb(49,117,209)",
    strokeOpacity: 1,
    strokeWidth: 2,
    d: " M3.5,-220 C3.5,-220 -295.7831726074219,-153.82395935058594 -295.7831726074219,-153.82395935058594"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,400,400)",
    opacity: 1,
    style: {
      display: "block"
    }
  }, _g33 || (_g33 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    fillOpacity: 0,
    strokeMiterlimit: 4,
    stroke: "rgb(49,117,209)",
    strokeOpacity: 1,
    strokeWidth: 2,
    d: " M3.5,-63 C3.5,-63 288.830078125,41.37802505493164 288.830078125,41.37802505493164"
  }))), _g34 || (_g34 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    fillOpacity: 0,
    strokeMiterlimit: 4,
    stroke: "rgb(49,117,209)",
    strokeOpacity: 1,
    strokeWidth: 2,
    d: " M274.5247802734375,-154.66941833496094 C274.5247802734375,-154.66941833496094 289.330078125,40.87802505493164 289.330078125,40.87802505493164"
  }))), _g35 || (_g35 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    fillOpacity: 0,
    strokeMiterlimit: 4,
    stroke: "rgb(49,117,209)",
    strokeOpacity: 1,
    strokeWidth: 2,
    d: " M201.75796508789062,-78.7261962890625 C201.75796508789062,-78.7261962890625 289.330078125,39.37802505493164 289.330078125,39.37802505493164"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,400,400)",
    opacity: 1,
    style: {
      display: "block"
    }
  }, _g36 || (_g36 = /*#__PURE__*/React.createElement("g", {
    opacity: 0,
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    fillOpacity: 0,
    strokeMiterlimit: 4,
    stroke: "rgb(49,117,209)",
    strokeOpacity: 1,
    strokeWidth: 2,
    d: " M337.7613220214844,-19.43092918395996 C337.7613220214844,-19.43092918395996 326.5,-39 326.5,-39"
  }))), _g37 || (_g37 = /*#__PURE__*/React.createElement("g", {
    opacity: 0,
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    fillOpacity: 0,
    strokeMiterlimit: 4,
    stroke: "rgb(49,117,209)",
    strokeOpacity: 1,
    strokeWidth: 2,
    d: " M298.75,-173.75 C298.75,-173.75 338.0113220214844,-21.43092918395996 338.0113220214844,-21.43092918395996"
  }))), _g38 || (_g38 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    fillOpacity: 0,
    strokeMiterlimit: 4,
    stroke: "rgb(49,117,209)",
    strokeOpacity: 1,
    strokeWidth: 2,
    d: " M274.5304870605469,-154.53048706054688 C274.5304870605469,-154.53048706054688 337.2613220214844,-21.43092918395996 337.2613220214844,-21.43092918395996"
  }))), _g39 || (_g39 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    fillOpacity: 0,
    strokeMiterlimit: 4,
    stroke: "rgb(49,117,209)",
    strokeOpacity: 1,
    strokeWidth: 2,
    d: " M289.5968322753906,39.96292495727539 C289.5968322753906,39.96292495727539 338.2613525390625,-19.430999755859375 338.2613525390625,-19.430999755859375"
  }))), _g40 || (_g40 = /*#__PURE__*/React.createElement("g", {
    opacity: 0,
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    fillOpacity: 0,
    strokeMiterlimit: 4,
    stroke: "rgb(49,117,209)",
    strokeOpacity: 1,
    strokeWidth: 2,
    d: " M293.75,169.5 C293.75,169.5 338.2613220214844,-17.93092918395996 338.2613220214844,-17.93092918395996"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,400,400)",
    opacity: 1,
    style: {
      display: "block"
    }
  }, _g41 || (_g41 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    fillOpacity: 0,
    strokeMiterlimit: 4,
    stroke: "rgb(49,117,209)",
    strokeOpacity: 1,
    strokeWidth: 2,
    d: " M299.9446716308594,156.79440307617188 C299.9446716308594,156.79440307617188 299.4446716308594,156.29440307617188 299.4446716308594,156.29440307617188 C299.4446716308594,156.29440307617188 195.89732360839844,216.9163818359375 195.89732360839844,216.9163818359375 C195.89732360839844,216.9163818359375 293.3782958984375,160.76095581054688 293.3782958984375,160.76095581054688 C293.3782958984375,160.76095581054688 298.4446716308594,156.79440307617188 298.4446716308594,156.79440307617188"
  }))), _g42 || (_g42 = /*#__PURE__*/React.createElement("g", {
    opacity: 0,
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    fillOpacity: 0,
    strokeMiterlimit: 4,
    stroke: "rgb(49,117,209)",
    strokeOpacity: 1,
    strokeWidth: 2,
    d: " M336.75,-1.5 C336.75,-1.5 299.6006774902344,157.6724090576172 299.6006774902344,157.6724090576172"
  }))), _g43 || (_g43 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    fillOpacity: 0,
    strokeMiterlimit: 4,
    stroke: "rgb(49,117,209)",
    strokeOpacity: 1,
    strokeWidth: 2,
    d: " M-2.5,130 C-2.5,130 300.6006774902344,157.6724090576172 300.6006774902344,157.6724090576172 C300.6006774902344,157.6724090576172 287.4388122558594,38.5827751159668 287.4388122558594,38.5827751159668"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,400,400)",
    opacity: 1,
    style: {
      display: "block"
    }
  }, _g44 || (_g44 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    fillOpacity: 0,
    strokeMiterlimit: 4,
    stroke: "rgb(49,117,209)",
    strokeOpacity: 1,
    strokeWidth: 2,
    d: " M51.71928787231445,214 C51.71928787231445,214 145.7418975830078,78.3212890625 145.7418975830078,78.3212890625 C145.7418975830078,78.3212890625 49.45232391357422,-80.26696014404297 49.45232391357422,-80.26696014404297"
  }))), _g45 || (_g45 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    fillOpacity: 0,
    strokeMiterlimit: 4,
    stroke: "rgb(49,117,209)",
    strokeOpacity: 1,
    strokeWidth: 2,
    d: " M200.1175079345703,-78.72394561767578 C200.1175079345703,-78.72394561767578 145.2418975830078,77.8212890625 145.2418975830078,77.8212890625"
  }))), _g46 || (_g46 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    fillOpacity: 0,
    strokeMiterlimit: 4,
    stroke: "rgb(49,117,209)",
    strokeOpacity: 1,
    strokeWidth: 2,
    d: " M287.9388122558594,40.009090423583984 C287.9388122558594,40.009090423583984 145.2418975830078,77.8212890625 145.2418975830078,77.8212890625"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,400,400)",
    opacity: 1,
    style: {
      display: "block"
    }
  }, _g47 || (_g47 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    fillOpacity: 0,
    strokeMiterlimit: 4,
    stroke: "rgb(49,117,209)",
    strokeOpacity: 1,
    strokeWidth: 2,
    d: " M3,-63 C3,-63 -35.23548126220703,86.53392791748047 -35.23548126220703,86.53392791748047 C-35.23548126220703,86.53392791748047 -112.08159637451172,-60.92084503173828 -112.08159637451172,-60.92084503173828"
  }))), _g48 || (_g48 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    fillOpacity: 0,
    strokeMiterlimit: 4,
    stroke: "rgb(49,117,209)",
    strokeOpacity: 1,
    strokeWidth: 2,
    d: " M47.21928787231445,-79.0678482055664 C47.21928787231445,-79.0678482055664 -37.23548126220703,86.53392791748047 -37.23548126220703,86.53392791748047 C-37.23548126220703,86.53392791748047 144.60842895507812,76.3212890625 144.60842895507812,76.3212890625"
  }))), _g49 || (_g49 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    fillOpacity: 0,
    strokeMiterlimit: 4,
    stroke: "rgb(49,117,209)",
    strokeOpacity: 1,
    strokeWidth: 2,
    d: " M53.47494125366211,213.87782287597656 C53.47494125366211,213.87782287597656 -37.23548126220703,86.53392791748047 -37.23548126220703,86.53392791748047"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,400,400)",
    opacity: 1,
    style: {
      display: "block"
    }
  }, _g50 || (_g50 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    fillOpacity: 0,
    strokeMiterlimit: 4,
    stroke: "rgb(49,117,209)",
    strokeOpacity: 1,
    strokeWidth: 2,
    d: " M-35.479827880859375,86.53392791748047 C-35.479827880859375,86.53392791748047 -207.1155242919922,66.36873626708984 -207.1155242919922,66.36873626708984 C-207.1155242919922,66.36873626708984 -111.45942687988281,-59.92084503173828 -111.45942687988281,-59.92084503173828"
  }))), _g51 || (_g51 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    fillOpacity: 0,
    strokeMiterlimit: 4,
    stroke: "rgb(49,117,209)",
    strokeOpacity: 1,
    strokeWidth: 2,
    d: " M-228.5181884765625,-120.86430358886719 C-228.5181884765625,-120.86430358886719 -207.1155242919922,66.36873626708984 -207.1155242919922,66.36873626708984"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,400,400)",
    opacity: 1,
    style: {
      display: "block"
    }
  }, _g52 || (_g52 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    fillOpacity: 0,
    strokeMiterlimit: 4,
    stroke: "rgb(49,117,209)",
    strokeOpacity: 1,
    strokeWidth: 2,
    d: " M-297,-144.5 C-297,-144.5 -323.88629150390625,21.15234375 -323.88629150390625,21.15234375"
  }))), _g53 || (_g53 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    fillOpacity: 0,
    strokeMiterlimit: 4,
    stroke: "rgb(49,117,209)",
    strokeOpacity: 1,
    strokeWidth: 2,
    d: " M-232.34982299804688,-121.09765625 C-232.34982299804688,-121.09765625 -324.38629150390625,21.65234375 -324.38629150390625,21.65234375"
  }))), _g54 || (_g54 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    fillOpacity: 0,
    strokeMiterlimit: 4,
    stroke: "rgb(49,117,209)",
    strokeOpacity: 1,
    strokeWidth: 2,
    d: " M3.5,-65 C3.5,-65 -324.38629150390625,20.65234375 -324.38629150390625,20.65234375 C-324.38629150390625,20.65234375 -207.87022399902344,66.08528900146484 -207.87022399902344,66.08528900146484"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,400,400)",
    opacity: 1,
    style: {
      display: "block"
    }
  }, _g55 || (_g55 = /*#__PURE__*/React.createElement("g", {
    opacity: 0,
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    fillOpacity: 0,
    strokeMiterlimit: 4,
    stroke: "rgb(49,117,209)",
    strokeOpacity: 1,
    strokeWidth: 2,
    d: " M-330,13.5 C-330,13.5 -306.5,147 -306.5,147"
  }))), _g56 || (_g56 = /*#__PURE__*/React.createElement("g", {
    opacity: 0,
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    fillOpacity: 0,
    strokeMiterlimit: 4,
    stroke: "rgb(49,117,209)",
    strokeOpacity: 1,
    strokeWidth: 2,
    d: " M-317,31.5 C-317,31.5 -329.5,-34.5 -329.5,-34.5"
  }))), _g57 || (_g57 = /*#__PURE__*/React.createElement("g", {
    opacity: 0,
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    fillOpacity: 0,
    strokeMiterlimit: 4,
    stroke: "rgb(49,117,209)",
    strokeOpacity: 1,
    strokeWidth: 2,
    d: " M-281.5,-182.5 C-281.5,-182.5 -330,13.25 -330,13.25"
  }))), _g58 || (_g58 = /*#__PURE__*/React.createElement("g", {
    opacity: 0,
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    fillOpacity: 0,
    strokeMiterlimit: 4,
    stroke: "rgb(49,117,209)",
    strokeOpacity: 1,
    strokeWidth: 2,
    d: " M-289.5,-133.5 C-289.5,-133.5 -334.5,-20.5 -334.5,-20.5"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,400,400)",
    opacity: 1,
    style: {
      display: "block"
    }
  }, _g59 || (_g59 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    fillOpacity: 0,
    strokeMiterlimit: 4,
    stroke: "rgb(49,117,209)",
    strokeOpacity: 1,
    strokeWidth: 2,
    d: " M196.23968505859375,217.3212890625 C196.23968505859375,217.3212890625 52.97494125366211,213.62217712402344 52.97494125366211,213.62217712402344"
  }))), _g60 || (_g60 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    fillOpacity: 0,
    strokeMiterlimit: 4,
    stroke: "rgb(49,117,209)",
    strokeOpacity: 1,
    strokeWidth: 2,
    d: " M145.10842895507812,75.8212890625 C145.10842895507812,75.8212890625 196.23968505859375,216.3212890625 196.23968505859375,216.3212890625"
  }))), _g61 || (_g61 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    fillOpacity: 0,
    strokeMiterlimit: 4,
    stroke: "rgb(49,117,209)",
    strokeOpacity: 1,
    strokeWidth: 2,
    d: " M287.56097412109375,38.49778366088867 C287.56097412109375,38.49778366088867 197.23968505859375,217.3212890625 197.23968505859375,217.3212890625"
  }))), _g62 || (_g62 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    fillOpacity: 0,
    strokeMiterlimit: 4,
    stroke: "rgb(49,117,209)",
    strokeOpacity: 1,
    strokeWidth: 2,
    d: "M0 0"
  }))), _g63 || (_g63 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    fillOpacity: 0,
    strokeMiterlimit: 4,
    stroke: "rgb(49,117,209)",
    strokeOpacity: 1,
    strokeWidth: 2,
    d: " M180.2239532470703,289.8212890625 C180.2239532470703,289.8212890625 196.23968505859375,217.8212890625 196.23968505859375,217.8212890625"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,400,400)",
    opacity: 1,
    style: {
      display: "block"
    }
  }, _g64 || (_g64 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    fillOpacity: 0,
    strokeMiterlimit: 4,
    stroke: "rgb(49,117,209)",
    strokeOpacity: 1,
    strokeWidth: 2,
    d: " M-1,132 C-1,132 -241.51795959472656,93.97959899902344 -241.51795959472656,93.97959899902344"
  }))), _g65 || (_g65 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    fillOpacity: 0,
    strokeMiterlimit: 4,
    stroke: "rgb(49,117,209)",
    strokeOpacity: 1,
    strokeWidth: 2,
    d: " M141.88026428222656,75.67649841308594 C141.88026428222656,75.67649841308594 -0.5,131.5 -0.5,131.5"
  }))), _g66 || (_g66 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    fillOpacity: 0,
    strokeMiterlimit: 4,
    stroke: "rgb(49,117,209)",
    strokeOpacity: 1,
    strokeWidth: 2,
    d: " M52.97494125366211,214.7443389892578 C52.97494125366211,214.7443389892578 -1,132 -1,132"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,400,400)",
    opacity: 1,
    style: {
      display: "block"
    }
  }, _g67 || (_g67 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    fillOpacity: 0,
    strokeMiterlimit: 4,
    stroke: "rgb(49,117,209)",
    strokeOpacity: 1,
    strokeWidth: 2,
    d: " M-323.1100158691406,19.7453556060791 C-323.1100158691406,19.7453556060791 -251.5612030029297,181.92613220214844 -251.5612030029297,181.92613220214844"
  }))), _g68 || (_g68 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    fillOpacity: 0,
    strokeMiterlimit: 4,
    stroke: "rgb(49,117,209)",
    strokeOpacity: 1,
    strokeWidth: 2,
    d: " M1,131 C1,131 -252.0612030029297,182.67613220214844 -252.0612030029297,182.67613220214844"
  }))), _g69 || (_g69 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    fillOpacity: 0,
    strokeMiterlimit: 4,
    stroke: "rgb(49,117,209)",
    strokeOpacity: 1,
    strokeWidth: 2,
    d: " M-208.3677520751953,66.26575469970703 C-208.3677520751953,66.26575469970703 -252.0612030029297,183.17613220214844 -252.0612030029297,183.17613220214844"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,400,400)",
    opacity: 1,
    style: {
      display: "block"
    }
  }, _g70 || (_g70 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    fillOpacity: 0,
    strokeMiterlimit: 4,
    stroke: "rgb(49,117,209)",
    strokeOpacity: 1,
    strokeWidth: 2,
    d: " M-291.1167297363281,163.87551879882812 C-291.1167297363281,163.87551879882812 -252.01548767089844,182.08367919921875 -252.01548767089844,182.08367919921875"
  }))), _g71 || (_g71 = /*#__PURE__*/React.createElement("g", {
    opacity: 0,
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    fillOpacity: 0,
    strokeMiterlimit: 4,
    stroke: "rgb(49,117,209)",
    strokeOpacity: 1,
    strokeWidth: 2,
    d: " M-309.75,136.5 C-309.75,136.5 -250,204 -250,204"
  }))), _g72 || (_g72 = /*#__PURE__*/React.createElement("g", {
    opacity: 0,
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    fillOpacity: 0,
    strokeMiterlimit: 4,
    stroke: "rgb(49,117,209)",
    strokeOpacity: 1,
    strokeWidth: 2,
    d: " M-316.5,28.5 C-316.5,28.5 -293,169.5 -293,169.5"
  }))), _g73 || (_g73 = /*#__PURE__*/React.createElement("g", {
    opacity: 0,
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    fillOpacity: 0,
    strokeMiterlimit: 4,
    stroke: "rgb(49,117,209)",
    strokeOpacity: 1,
    strokeWidth: 2,
    d: " M-340.5,-9 C-340.5,-9 -278.5,189.5 -278.5,189.5"
  }))), _g74 || (_g74 = /*#__PURE__*/React.createElement("g", {
    opacity: 0,
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    fillOpacity: 0,
    strokeMiterlimit: 4,
    stroke: "rgb(49,117,209)",
    strokeOpacity: 1,
    strokeWidth: 2,
    d: " M-184.18800354003906,279.375 C-184.18800354003906,279.375 -248.43800354003906,205.875 -248.43800354003906,205.875"
  }))), _g75 || (_g75 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    fillOpacity: 0,
    strokeMiterlimit: 4,
    stroke: "rgb(49,117,209)",
    strokeOpacity: 1,
    strokeWidth: 2,
    d: " M-174,295.5"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "rgb(49,117,209)",
    fillOpacity: 1,
    d: " M-174,295.5"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,400,400)",
    opacity: 1,
    style: {
      display: "block"
    }
  }, _g76 || (_g76 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    fillOpacity: 0,
    strokeMiterlimit: 4,
    stroke: "rgb(49,117,209)",
    strokeOpacity: 1,
    strokeWidth: 2,
    d: " M33.171836853027344,318.86651611328125 C33.171836853027344,318.86651611328125 53.59711456298828,214.12217712402344 53.59711456298828,214.12217712402344"
  }))), _g77 || (_g77 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    fillOpacity: 0,
    strokeMiterlimit: 4,
    stroke: "rgb(49,117,209)",
    strokeOpacity: 1,
    strokeWidth: 2,
    d: " M196.1175079345703,217.19911193847656 C196.1175079345703,217.19911193847656 33.671836853027344,318.36651611328125 33.671836853027344,318.36651611328125"
  }))), _g78 || (_g78 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    fillOpacity: 0,
    strokeMiterlimit: 4,
    stroke: "rgb(49,117,209)",
    strokeOpacity: 1,
    strokeWidth: 2,
    d: " M180.59046936035156,289.8212890625 C180.59046936035156,289.8212890625 32.91618347167969,317.7443542480469 32.91618347167969,317.7443542480469"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,400,400)",
    opacity: 1,
    style: {
      display: "block"
    }
  }, _g79 || (_g79 = /*#__PURE__*/React.createElement("g", {
    opacity: 0,
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    fillOpacity: 0,
    strokeMiterlimit: 4,
    stroke: "rgb(49,117,209)",
    strokeOpacity: 1,
    strokeWidth: 2,
    d: " M-2,337.5 C-2,337.5 183.5,281 183.5,281"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,400,400)",
    opacity: 1,
    style: {
      display: "block"
    }
  }, _g80 || (_g80 = /*#__PURE__*/React.createElement("g", {
    opacity: 0,
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    fillOpacity: 0,
    strokeMiterlimit: 4,
    stroke: "rgb(49,117,209)",
    strokeOpacity: 1,
    strokeWidth: 2,
    d: " M-154.68150329589844,303.58056640625 C-154.68150329589844,303.58056640625 -282.468994140625,187.125 -282.468994140625,187.125"
  }))), _g81 || (_g81 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    fillOpacity: 0,
    strokeMiterlimit: 4,
    stroke: "rgb(49,117,209)",
    strokeOpacity: 1,
    strokeWidth: 2,
    d: " M-250.6844940185547,182.97959899902344 C-250.6844940185547,182.97959899902344 -155.90049743652344,301.58056640625 -155.90049743652344,301.58056640625"
  }))), _g82 || (_g82 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    fillOpacity: 0,
    strokeMiterlimit: 4,
    stroke: "rgb(49,117,209)",
    strokeOpacity: 1,
    strokeWidth: 2,
    d: " M32.82229995727539,318.1300964355469 C32.82229995727539,318.1300964355469 -155.15049743652344,302.33056640625 -155.15049743652344,302.33056640625"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "rgb(49,117,209)",
    fillOpacity: 1,
    d: " M32.82229995727539,318.1300964355469 C32.82229995727539,318.1300964355469 -155.15049743652344,302.33056640625 -155.15049743652344,302.33056640625"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,400,400)",
    opacity: 1,
    style: {
      display: "block"
    }
  }, _g83 || (_g83 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    fillOpacity: 0,
    strokeMiterlimit: 4,
    stroke: "rgb(49,117,209)",
    strokeOpacity: 1,
    strokeWidth: 2,
    d: " M53.09711456298828,213.5 C53.09711456298828,213.5 -109.8372573852539,228.1787109375 -109.8372573852539,228.1787109375 C-109.8372573852539,228.1787109375 -248.32815551757812,182.10177612304688 -248.32815551757812,182.10177612304688"
  }))), _g84 || (_g84 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    fillOpacity: 0,
    strokeMiterlimit: 4,
    stroke: "rgb(49,117,209)",
    strokeOpacity: 1,
    strokeWidth: 2,
    d: " M-206.35421752929688,65.61873626708984 C-206.35421752929688,65.61873626708984 -108.3372573852539,229.9287109375 -108.3372573852539,229.9287109375"
  }))), _g85 || (_g85 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    fillOpacity: 0,
    strokeMiterlimit: 4,
    stroke: "rgb(49,117,209)",
    strokeOpacity: 1,
    strokeWidth: 2,
    d: " M35.04966354370117,317.8778381347656 C35.04966354370117,317.8778381347656 -110.3372573852539,228.6787109375 -110.3372573852539,228.6787109375"
  }))), _g86 || (_g86 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    fillOpacity: 0,
    strokeMiterlimit: 4,
    stroke: "rgb(49,117,209)",
    strokeOpacity: 1,
    strokeWidth: 2,
    d: " M-109.10515594482422,229.99151611328125 C-109.10515594482422,229.99151611328125 -154.99212646484375,303.4230651855469 -154.99212646484375,303.4230651855469"
  }))), _g87 || (_g87 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    fillOpacity: 0,
    strokeMiterlimit: 4,
    stroke: "rgb(49,117,209)",
    strokeOpacity: 1,
    strokeWidth: 2,
    d: " M-35.8576545715332,85.51130676269531 C-35.8576545715332,85.51130676269531 -109.5872573852539,230.0537109375 -109.5872573852539,230.0537109375"
  }))))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#__lottie_element_32)",
    transform: "matrix(1,0,0,1,0,0)",
    opacity: 1,
    style: {
      display: "block"
    }
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,400,400)",
    opacity: 1,
    style: {
      display: "block"
    }
  }, _g88 || (_g88 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,3.5,-63.5)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "rgb(49,117,209)",
    fillOpacity: 1,
    d: " M0,-7.5 C4.142000198364258,-7.5 7.5,-4.142000198364258 7.5,0 C7.5,4.142000198364258 4.142000198364258,7.5 0,7.5 C-4.142000198364258,7.5 -7.5,4.142000198364258 -7.5,0 C-7.5,-4.142000198364258 -4.142000198364258,-7.5 0,-7.5z"
  }))), _g89 || (_g89 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,205,113)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "rgb(49,117,209)",
    fillOpacity: 1,
    d: " M-413.9830322265625,-54.71992492675781 C-409.8410339355469,-54.71992492675781 -406.4830322265625,-51.36192321777344 -406.4830322265625,-47.21992492675781 C-406.4830322265625,-43.07792282104492 -409.8410339355469,-39.71992492675781 -413.9830322265625,-39.71992492675781 C-418.1250305175781,-39.71992492675781 -421.4830322265625,-43.07792282104492 -421.4830322265625,-47.21992492675781 C-421.4830322265625,-51.36192321777344 -418.1250305175781,-54.71992492675781 -413.9830322265625,-54.71992492675781z"
  }))), _g90 || (_g90 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,96,-40)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "rgb(49,117,209)",
    fillOpacity: 1,
    d: " M-95.5,-279.5 C-91.35800170898438,-279.5 -88,-276.1419982910156 -88,-272 C-88,-267.8580017089844 -91.35800170898438,-264.5 -95.5,-264.5 C-99.64199829101562,-264.5 -103,-267.8580017089844 -103,-272 C-103,-276.1419982910156 -99.64199829101562,-279.5 -95.5,-279.5z"
  }))), _g91 || (_g91 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "rgb(49,117,209)",
    fillOpacity: 1,
    d: " M-110.75714111328125,222.19973754882812 C-106.61514282226562,222.19973754882812 -103.25714111328125,225.5577392578125 -103.25714111328125,229.69973754882812 C-103.25714111328125,233.8417510986328 -106.61514282226562,237.19973754882812 -110.75714111328125,237.19973754882812 C-114.89913940429688,237.19973754882812 -118.25714111328125,233.8417510986328 -118.25714111328125,229.69973754882812 C-118.25714111328125,225.5577392578125 -114.89913940429688,222.19973754882812 -110.75714111328125,222.19973754882812z"
  }))), _g92 || (_g92 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "rgb(49,117,209)",
    fillOpacity: 1,
    d: " M52.82514572143555,206.05960083007812 C56.96714401245117,206.05960083007812 60.32514572143555,209.4176025390625 60.32514572143555,213.55960083007812 C60.32514572143555,217.70159912109375 56.96714401245117,221.05960083007812 52.82514572143555,221.05960083007812 C48.683143615722656,221.05960083007812 45.32514572143555,217.70159912109375 45.32514572143555,213.55960083007812 C45.32514572143555,209.4176025390625 48.683143615722656,206.05960083007812 52.82514572143555,206.05960083007812z"
  }))), _g93 || (_g93 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "rgb(49,117,209)",
    fillOpacity: 1,
    d: " M-1.4249999523162842,123.92500305175781 C2.7170000076293945,123.92500305175781 6.074999809265137,127.28299713134766 6.074999809265137,131.4250030517578 C6.074999809265137,135.56700134277344 2.7170000076293945,138.9250030517578 -1.4249999523162842,138.9250030517578 C-5.566999912261963,138.9250030517578 -8.925000190734863,135.56700134277344 -8.925000190734863,131.4250030517578 C-8.925000190734863,127.28299713134766 -5.566999912261963,123.92500305175781 -1.4249999523162842,123.92500305175781z"
  }))), _g94 || (_g94 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "rgb(49,117,209)",
    fillOpacity: 1,
    d: " M-252.32032775878906,174.05484008789062 C-248.17832946777344,174.05484008789062 -244.82032775878906,177.412841796875 -244.82032775878906,181.55484008789062 C-244.82032775878906,185.69683837890625 -248.17832946777344,189.05484008789062 -252.32032775878906,189.05484008789062 C-256.46234130859375,189.05484008789062 -259.8203125,185.69683837890625 -259.8203125,181.55484008789062 C-259.8203125,177.412841796875 -256.46234130859375,174.05484008789062 -252.32032775878906,174.05484008789062z"
  }))), _g95 || (_g95 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "rgb(49,117,209)",
    fillOpacity: 1,
    d: " M32.04621887207031,309.8778991699219 C36.18821716308594,309.8778991699219 39.54621887207031,313.23590087890625 39.54621887207031,317.3778991699219 C39.54621887207031,321.5198974609375 36.18821716308594,324.8778991699219 32.04621887207031,324.8778991699219 C27.904218673706055,324.8778991699219 24.546218872070312,321.5198974609375 24.546218872070312,317.3778991699219 C24.546218872070312,313.23590087890625 27.904218673706055,309.8778991699219 32.04621887207031,309.8778991699219z"
  }))), _g96 || (_g96 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,194,-268.5)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "rgb(49,117,209)",
    fillOpacity: 1,
    d: " M-48.141204833984375,338.11126708984375 C-43.999202728271484,338.11126708984375 -40.641204833984375,341.4692687988281 -40.641204833984375,345.61126708984375 C-40.641204833984375,349.7532653808594 -43.999202728271484,353.11126708984375 -48.141204833984375,353.11126708984375 C-52.283203125,353.11126708984375 -55.641204833984375,349.7532653808594 -55.641204833984375,345.61126708984375 C-55.641204833984375,341.4692687988281 -52.283203125,338.11126708984375 -48.141204833984375,338.11126708984375z"
  }))), _g97 || (_g97 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,176,-416)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "rgb(49,117,209)",
    fillOpacity: 1,
    d: " M25.71332359313965,329.779541015625 C29.855323791503906,329.779541015625 33.213321685791016,333.1375427246094 33.213321685791016,337.279541015625 C33.213321685791016,341.4215393066406 29.855323791503906,344.779541015625 25.71332359313965,344.779541015625 C21.57132339477539,344.779541015625 18.21332359313965,341.4215393066406 18.21332359313965,337.279541015625 C18.21332359313965,333.1375427246094 21.57132339477539,329.779541015625 25.71332359313965,329.779541015625z"
  }))), _g98 || (_g98 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,-100,-518.5)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "rgb(49,117,209)",
    fillOpacity: 1,
    d: " M33.3815803527832,301.406982421875 C37.52357864379883,301.406982421875 40.8815803527832,304.7649841308594 40.8815803527832,308.906982421875 C40.8815803527832,313.0489807128906 37.52357864379883,316.406982421875 33.3815803527832,316.406982421875 C29.239578247070312,316.406982421875 25.88157844543457,313.0489807128906 25.88157844543457,308.906982421875 C25.88157844543457,304.7649841308594 29.239578247070312,301.406982421875 33.3815803527832,301.406982421875z"
  }))), _g99 || (_g99 = /*#__PURE__*/React.createElement("g", {
    opacity: 0,
    transform: "matrix(0.8939803838729858,0,0,0.894295334815979,-241,-290.5)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "rgb(49,117,209)",
    fillOpacity: 1,
    d: " M186.6654510498047,68.82275390625 C176.44845581054688,68.82275390625 168.1654510498047,77.10575103759766 168.1654510498047,87.32275390625 C168.1654510498047,97.53974914550781 176.44845581054688,105.82275390625 186.6654510498047,105.82275390625 C196.88246154785156,105.82275390625 205.1654510498047,97.53974914550781 205.1654510498047,87.32275390625 C205.1654510498047,77.10575103759766 196.88246154785156,68.82275390625 186.6654510498047,68.82275390625z"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    fillOpacity: 0,
    strokeMiterlimit: 4,
    stroke: "rgb(49,117,209)",
    strokeOpacity: 1,
    strokeWidth: 0,
    d: " M186.6654510498047,68.82275390625 C176.44845581054688,68.82275390625 168.1654510498047,77.10575103759766 168.1654510498047,87.32275390625 C168.1654510498047,97.53974914550781 176.44845581054688,105.82275390625 186.6654510498047,105.82275390625 C196.88246154785156,105.82275390625 205.1654510498047,97.53974914550781 205.1654510498047,87.32275390625 C205.1654510498047,77.10575103759766 196.88246154785156,68.82275390625 186.6654510498047,68.82275390625z"
  }))), _g100 || (_g100 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,69.5,-555.5)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "rgb(49,117,209)",
    fillOpacity: 1,
    d: " M51.71226119995117,324.9112243652344 C55.8542594909668,324.9112243652344 59.21226119995117,328.26922607421875 59.21226119995117,332.4112243652344 C59.21226119995117,336.55322265625 55.8542594909668,339.9112243652344 51.71226119995117,339.9112243652344 C47.57025909423828,339.9112243652344 44.21226119995117,336.55322265625 44.21226119995117,332.4112243652344 C44.21226119995117,328.26922607421875 47.57025909423828,324.9112243652344 51.71226119995117,324.9112243652344z"
  }))), _g101 || (_g101 = /*#__PURE__*/React.createElement("g", {
    opacity: 0,
    transform: "matrix(0.7544432282447815,0,0,0.791572630405426,-241,-290.5)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "rgb(49,117,209)",
    fillOpacity: 1,
    d: " M572.395263671875,215.1746368408203 C562.629150390625,215.1746368408203 554.7115478515625,223.01858520507812 554.7115478515625,232.69468688964844 C554.7115478515625,242.37078857421875 562.629150390625,250.21473693847656 572.395263671875,250.21473693847656 C582.1613159179688,250.21473693847656 590.0774536132812,242.37078857421875 590.0774536132812,232.69468688964844 C590.0774536132812,223.01858520507812 582.1613159179688,215.1746368408203 572.395263671875,215.1746368408203z"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    fillOpacity: 0,
    strokeMiterlimit: 4,
    stroke: "rgb(49,117,209)",
    strokeOpacity: 1,
    strokeWidth: 0,
    d: " M572.395263671875,215.1746368408203 C562.629150390625,215.1746368408203 554.7115478515625,223.01858520507812 554.7115478515625,232.69468688964844 C554.7115478515625,242.37078857421875 562.629150390625,250.21473693847656 572.395263671875,250.21473693847656 C582.1613159179688,250.21473693847656 590.0774536132812,242.37078857421875 590.0774536132812,232.69468688964844 C590.0774536132812,223.01858520507812 582.1613159179688,215.1746368408203 572.395263671875,215.1746368408203z"
  }))), _g102 || (_g102 = /*#__PURE__*/React.createElement("g", {
    opacity: 0,
    transform: "matrix(1,0,0,1,-249,-568.5)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "rgb(49,117,209)",
    fillOpacity: 1,
    d: " M74.32499694824219,291.17498779296875 C78.46700286865234,291.17498779296875 81.82499694824219,294.5329895019531 81.82499694824219,298.67498779296875 C81.82499694824219,302.8169860839844 78.46700286865234,306.17498779296875 74.32499694824219,306.17498779296875 C70.18299865722656,306.17498779296875 66.82499694824219,302.8169860839844 66.82499694824219,298.67498779296875 C66.82499694824219,294.5329895019531 70.18299865722656,291.17498779296875 74.32499694824219,291.17498779296875z"
  }))), _g103 || (_g103 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,42,-402.5)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "rgb(49,117,209)",
    fillOpacity: 1,
    d: " M5.967566013336182,315.40155029296875 C10.109565734863281,315.40155029296875 13.467565536499023,318.7595520019531 13.467565536499023,322.90155029296875 C13.467565536499023,327.0435485839844 10.109565734863281,330.40155029296875 5.967566013336182,330.40155029296875 C1.8255659341812134,330.40155029296875 -1.5324339866638184,327.0435485839844 -1.5324339866638184,322.90155029296875 C-1.5324339866638184,318.7595520019531 1.8255659341812134,315.40155029296875 5.967566013336182,315.40155029296875z"
  }))), _g104 || (_g104 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,-78.5,-535.5)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "rgb(49,117,209)",
    fillOpacity: 1,
    d: " M82.07499694824219,307.92498779296875 C86.21700286865234,307.92498779296875 89.57499694824219,311.2829895019531 89.57499694824219,315.42498779296875 C89.57499694824219,319.5669860839844 86.21700286865234,322.92498779296875 82.07499694824219,322.92498779296875 C77.93299865722656,322.92498779296875 74.57499694824219,319.5669860839844 74.57499694824219,315.42498779296875 C74.57499694824219,311.2829895019531 77.93299865722656,307.92498779296875 82.07499694824219,307.92498779296875z"
  }))), _g105 || (_g105 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,-262.5,-415)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "rgb(49,117,209)",
    fillOpacity: 1,
    d: " M30.364286422729492,285.98712158203125 C34.50628662109375,285.98712158203125 37.864288330078125,289.3451232910156 37.864288330078125,293.48712158203125 C37.864288330078125,297.6291198730469 34.50628662109375,300.98712158203125 30.364286422729492,300.98712158203125 C26.222286224365234,300.98712158203125 22.864286422729492,297.6291198730469 22.864286422729492,293.48712158203125 C22.864286422729492,289.3451232910156 26.222286224365234,285.98712158203125 30.364286422729492,285.98712158203125z"
  }))), _g106 || (_g106 = /*#__PURE__*/React.createElement("g", {
    opacity: 0,
    transform: "matrix(1,0,0,1,-367,-440)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "rgb(49,117,209)",
    fillOpacity: 1,
    d: " M47.255001068115234,455.7650146484375 C51.39699935913086,455.7650146484375 54.755001068115234,459.12298583984375 54.755001068115234,463.2650146484375 C54.755001068115234,467.4070129394531 51.39699935913086,470.7650146484375 47.255001068115234,470.7650146484375 C43.112998962402344,470.7650146484375 39.755001068115234,467.4070129394531 39.755001068115234,463.2650146484375 C39.755001068115234,459.12298583984375 43.112998962402344,455.7650146484375 47.255001068115234,455.7650146484375z"
  }))), _g107 || (_g107 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,-117,-365)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "rgb(49,117,209)",
    fillOpacity: 1,
    d: " M3.858795642852783,298.3396911621094 C8.000795364379883,298.3396911621094 11.358796119689941,301.69769287109375 11.358796119689941,305.8396911621094 C11.358796119689941,309.981689453125 8.000795364379883,313.3396911621094 3.858795642852783,313.3396911621094 C-0.28320425748825073,313.3396911621094 -3.641204357147217,309.981689453125 -3.641204357147217,305.8396911621094 C-3.641204357147217,301.69769287109375 -0.28320425748825073,298.3396911621094 3.858795642852783,298.3396911621094z"
  }))), _g108 || (_g108 = /*#__PURE__*/React.createElement("g", {
    opacity: 0,
    transform: "matrix(1,0,0,1,-362,-271)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "rgb(49,117,209)",
    fillOpacity: 1,
    d: " M45.415000915527344,290.89300537109375 C49.55699920654297,290.89300537109375 52.915000915527344,294.2510070800781 52.915000915527344,298.39300537109375 C52.915000915527344,302.5350036621094 49.55699920654297,305.89300537109375 45.415000915527344,305.89300537109375 C41.27299880981445,305.89300537109375 37.915000915527344,302.5350036621094 37.915000915527344,298.39300537109375 C37.915000915527344,294.2510070800781 41.27299880981445,290.89300537109375 45.415000915527344,290.89300537109375z"
  }))), _g109 || (_g109 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,-26,-227.5)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "rgb(49,117,209)",
    fillOpacity: 1,
    d: " M-11.0943021774292,306.391357421875 C-6.952301979064941,306.391357421875 -3.594302177429199,309.7493591308594 -3.594302177429199,313.891357421875 C-3.594302177429199,318.0333557128906 -6.952301979064941,321.391357421875 -11.0943021774292,321.391357421875 C-15.236302375793457,321.391357421875 -18.594301223754883,318.0333557128906 -18.594301223754883,313.891357421875 C-18.594301223754883,309.7493591308594 -15.236302375793457,306.391357421875 -11.0943021774292,306.391357421875z"
  }))), _g110 || (_g110 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.05250193548387188,
    transform: "matrix(0.9029592275619507,0,0,0.908973217010498,-241,-290.5)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "rgb(49,117,209)",
    fillOpacity: 1,
    d: " M225.53651428222656,395.9190673828125 C215.31951904296875,395.9190673828125 207.03651428222656,404.20208740234375 207.03651428222656,414.4190673828125 C207.03651428222656,424.6360778808594 215.31951904296875,432.9190673828125 225.53651428222656,432.9190673828125 C235.75350952148438,432.9190673828125 244.03651428222656,424.6360778808594 244.03651428222656,414.4190673828125 C244.03651428222656,404.20208740234375 235.75350952148438,395.9190673828125 225.53651428222656,395.9190673828125z"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    fillOpacity: 0,
    strokeMiterlimit: 4,
    stroke: "rgb(49,117,209)",
    strokeOpacity: 1,
    strokeWidth: 0.3818322580645228,
    d: " M225.53651428222656,395.9190673828125 C215.31951904296875,395.9190673828125 207.03651428222656,404.20208740234375 207.03651428222656,414.4190673828125 C207.03651428222656,424.6360778808594 215.31951904296875,432.9190673828125 225.53651428222656,432.9190673828125 C235.75350952148438,432.9190673828125 244.03651428222656,424.6360778808594 244.03651428222656,414.4190673828125 C244.03651428222656,404.20208740234375 235.75350952148438,395.9190673828125 225.53651428222656,395.9190673828125z"
  }))), _g111 || (_g111 = /*#__PURE__*/React.createElement("g", {
    opacity: 0,
    transform: "matrix(1,0,0,1,-26,-227.5)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "rgb(49,117,209)",
    fillOpacity: 1,
    d: " M-228.4250030517578,422.92498779296875 C-224.2830047607422,422.92498779296875 -220.9250030517578,426.2829895019531 -220.9250030517578,430.42498779296875 C-220.9250030517578,434.5669860839844 -224.2830047607422,437.92498779296875 -228.4250030517578,437.92498779296875 C-232.56700134277344,437.92498779296875 -235.9250030517578,434.5669860839844 -235.9250030517578,430.42498779296875 C-235.9250030517578,426.2829895019531 -232.56700134277344,422.92498779296875 -228.4250030517578,422.92498779296875z"
  }))), _g112 || (_g112 = /*#__PURE__*/React.createElement("g", {
    opacity: 0,
    transform: "matrix(1,0,0,1,-26.5,-227.5)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "rgb(49,117,209)",
    fillOpacity: 1,
    d: " M-263.17498779296875,86.92500305175781 C-259.0329895019531,86.92500305175781 -255.6750030517578,90.28299713134766 -255.6750030517578,94.42500305175781 C-255.6750030517578,98.56700134277344 -259.0329895019531,101.92500305175781 -263.17498779296875,101.92500305175781 C-267.3169860839844,101.92500305175781 -270.67498779296875,98.56700134277344 -270.67498779296875,94.42500305175781 C-270.67498779296875,90.28299713134766 -267.3169860839844,86.92500305175781 -263.17498779296875,86.92500305175781z"
  }))), _g113 || (_g113 = /*#__PURE__*/React.createElement("g", {
    opacity: 0,
    transform: "matrix(1,0,0,1,-26.5,-227.5)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "rgb(49,117,209)",
    fillOpacity: 1,
    d: " M303.8429870605469,393.05999755859375 C307.9849853515625,393.05999755859375 311.3429870605469,396.4179992675781 311.3429870605469,400.55999755859375 C311.3429870605469,404.7019958496094 307.9849853515625,408.05999755859375 303.8429870605469,408.05999755859375 C299.70098876953125,408.05999755859375 296.3429870605469,404.7019958496094 296.3429870605469,400.55999755859375 C296.3429870605469,396.4179992675781 299.70098876953125,393.05999755859375 303.8429870605469,393.05999755859375z"
  }))), _g114 || (_g114 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,-26.5,-227.5)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "rgb(49,117,209)",
    fillOpacity: 1,
    d: " M315.9321594238281,258.67010498046875 C320.07415771484375,258.67010498046875 323.4321594238281,262.0281066894531 323.4321594238281,266.17010498046875 C323.4321594238281,270.3121337890625 320.07415771484375,273.67010498046875 315.9321594238281,273.67010498046875 C311.7901611328125,273.67010498046875 308.4321594238281,270.3121337890625 308.4321594238281,266.17010498046875 C308.4321594238281,262.0281066894531 311.7901611328125,258.67010498046875 315.9321594238281,258.67010498046875z"
  }))), _g115 || (_g115 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,-26.5,-227.5)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "rgb(49,117,209)",
    fillOpacity: 1,
    d: " M223.87132263183594,436.74505615234375 C228.01332092285156,436.74505615234375 231.37132263183594,440.1030578613281 231.37132263183594,444.24505615234375 C231.37132263183594,448.3870544433594 228.01332092285156,451.74505615234375 223.87132263183594,451.74505615234375 C219.7293243408203,451.74505615234375 216.37132263183594,448.3870544433594 216.37132263183594,444.24505615234375 C216.37132263183594,440.1030578613281 219.7293243408203,436.74505615234375 223.87132263183594,436.74505615234375z"
  }))), _g116 || (_g116 = /*#__PURE__*/React.createElement("g", {
    opacity: 0,
    transform: "matrix(1,0,0,1,194,-268.5)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "rgb(49,117,209)",
    fillOpacity: 1,
    d: " M122.07499694824219,281.92498779296875 C126.21700286865234,281.92498779296875 129.5749969482422,285.2829895019531 129.5749969482422,289.42498779296875 C129.5749969482422,293.5669860839844 126.21700286865234,296.92498779296875 122.07499694824219,296.92498779296875 C117.93299865722656,296.92498779296875 114.57499694824219,293.5669860839844 114.57499694824219,289.42498779296875 C114.57499694824219,285.2829895019531 117.93299865722656,281.92498779296875 122.07499694824219,281.92498779296875z"
  }))), _g117 || (_g117 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,194,-268.5)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "rgb(49,117,209)",
    fillOpacity: 1,
    d: " M80.6350326538086,106.39857482910156 C84.77703857421875,106.39857482910156 88.1350326538086,109.75657653808594 88.1350326538086,113.89857482910156 C88.1350326538086,118.04057312011719 84.77703857421875,121.39857482910156 80.6350326538086,121.39857482910156 C76.49303436279297,121.39857482910156 73.1350326538086,118.04057312011719 73.1350326538086,113.89857482910156 C73.1350326538086,109.75657653808594 76.49303436279297,106.39857482910156 80.6350326538086,106.39857482910156z"
  }))), _g118 || (_g118 = /*#__PURE__*/React.createElement("g", {
    opacity: 0,
    transform: "matrix(1,0,0,1,194,-268.5)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "rgb(49,117,209)",
    fillOpacity: 1,
    d: " M-276.1159973144531,575.7479858398438 C-271.9739990234375,575.7479858398438 -268.6159973144531,579.1060180664062 -268.6159973144531,583.2479858398438 C-268.6159973144531,587.3900146484375 -271.9739990234375,590.7479858398438 -276.1159973144531,590.7479858398438 C-280.25799560546875,590.7479858398438 -283.6159973144531,587.3900146484375 -283.6159973144531,583.2479858398438 C-283.6159973144531,579.1060180664062 -280.25799560546875,575.7479858398438 -276.1159973144531,575.7479858398438z"
  }))))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#__lottie_element_4)",
    transform: "matrix(1,0,0,1,0,0)",
    opacity: 1,
    style: {
      display: "block"
    }
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,404,396.5)",
    opacity: 1,
    style: {
      display: "block"
    }
  }, _g119 || (_g119 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    fillOpacity: 0,
    strokeMiterlimit: 4,
    stroke: "rgb(49,117,209)",
    strokeOpacity: 1,
    strokeWidth: 2,
    d: " M-175.30088806152344,-271.00909423828125 C-175.30088806152344,-271.00909423828125 -40.694454193115234,-333.6108703613281 -40.694454193115234,-333.6108703613281"
  }))), _g120 || (_g120 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,-147,-306.5)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "rgb(49,117,209)",
    fillOpacity: 1,
    d: " M-29.050886154174805,27.740907669067383 C-24.908885955810547,27.740907669067383 -21.550886154174805,31.098907470703125 -21.550886154174805,35.240909576416016 C-21.550886154174805,39.38290786743164 -24.908885955810547,42.740909576416016 -29.050886154174805,42.740909576416016 C-33.19288635253906,42.740909576416016 -36.55088806152344,39.38290786743164 -36.55088806152344,35.240909576416016 C-36.55088806152344,31.098907470703125 -33.19288635253906,27.740907669067383 -29.050886154174805,27.740907669067383z"
  }))), _g121 || (_g121 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    fillOpacity: 0,
    strokeMiterlimit: 4,
    stroke: "rgb(49,117,209)",
    strokeOpacity: 1,
    strokeWidth: 2,
    d: " M-68.33236694335938,-250.97738647460938 C-68.33236694335938,-250.97738647460938 -40.694454193115234,-333.6108703613281 -40.694454193115234,-333.6108703613281"
  }))), _g122 || (_g122 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    fillOpacity: 0,
    strokeMiterlimit: 4,
    stroke: "rgb(49,117,209)",
    strokeOpacity: 1,
    strokeWidth: 2,
    d: " M-221.85055541992188,-235.3643035888672 C-221.85055541992188,-235.3643035888672 -68.33236694335938,-250.0995635986328 -68.33236694335938,-250.0995635986328"
  }))), _g123 || (_g123 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    fillOpacity: 0,
    strokeMiterlimit: 4,
    stroke: "rgb(49,117,209)",
    strokeOpacity: 1,
    strokeWidth: 2,
    d: " M-67.83236694335938,-250.47738647460938 C-67.83236694335938,-250.47738647460938 126.04767608642578,-262.357421875 126.04767608642578,-262.357421875"
  }))), _g124 || (_g124 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    fillOpacity: 0,
    strokeMiterlimit: 4,
    stroke: "rgb(49,117,209)",
    strokeOpacity: 1,
    strokeWidth: 2,
    d: " M126.04767608642578,-261.857421875 C126.04767608642578,-261.857421875 -40.694454193115234,-333.6108703613281 -40.694454193115234,-333.6108703613281"
  }))), _g125 || (_g125 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,-147,-306.5)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    fillOpacity: 0,
    strokeMiterlimit: 4,
    stroke: "rgb(49,117,209)",
    strokeOpacity: 1,
    strokeWidth: 2,
    d: " M296.3982238769531,10.386919021606445 C296.3982238769531,10.386919021606445 107.30554962158203,-26.110864639282227 107.30554962158203,-26.110864639282227"
  }))), _g126 || (_g126 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,-147,-306.5)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "rgb(49,117,209)",
    fillOpacity: 1,
    d: " M105.80554962158203,-34.11086654663086 C109.94754791259766,-34.11086654663086 113.30554962158203,-30.752864837646484 113.30554962158203,-26.610864639282227 C113.30554962158203,-22.46886444091797 109.94754791259766,-19.110864639282227 105.80554962158203,-19.110864639282227 C101.66354370117188,-19.110864639282227 98.30554962158203,-22.46886444091797 98.30554962158203,-26.610864639282227 C98.30554962158203,-30.752864837646484 101.66354370117188,-34.11086654663086 105.80554962158203,-34.11086654663086z"
  }))), _g127 || (_g127 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,-147,-306.5)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "rgb(49,117,209)",
    fillOpacity: 1,
    d: " M78.66763305664062,49.02261734008789 C82.80963134765625,49.02261734008789 86.16763305664062,52.380615234375 86.16763305664062,56.52261734008789 C86.16763305664062,60.664615631103516 82.80963134765625,64.02261352539062 78.66763305664062,64.02261352539062 C74.525634765625,64.02261352539062 71.16763305664062,60.664615631103516 71.16763305664062,56.52261734008789 C71.16763305664062,52.380615234375 74.525634765625,49.02261734008789 78.66763305664062,49.02261734008789z"
  }))), _g128 || (_g128 = /*#__PURE__*/React.createElement("g", {
    opacity: 0,
    transform: "matrix(0.9599999785423279,0,0,0.9599999785423279,-241,-290.5)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "rgb(49,117,209)",
    fillOpacity: 1,
    d: " M204.11500549316406,173.70799255371094 C193.8979949951172,173.70799255371094 185.61500549316406,181.99099731445312 185.61500549316406,192.20799255371094 C185.61500549316406,202.4250030517578 193.8979949951172,210.70799255371094 204.11500549316406,210.70799255371094 C214.33200073242188,210.70799255371094 222.61500549316406,202.4250030517578 222.61500549316406,192.20799255371094 C222.61500549316406,181.99099731445312 214.33200073242188,173.70799255371094 204.11500549316406,173.70799255371094z"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    fillOpacity: 0,
    strokeMiterlimit: 4,
    stroke: "rgb(49,117,209)",
    strokeOpacity: 1,
    strokeWidth: 0,
    d: " M204.11500549316406,173.70799255371094 C193.8979949951172,173.70799255371094 185.61500549316406,181.99099731445312 185.61500549316406,192.20799255371094 C185.61500549316406,202.4250030517578 193.8979949951172,210.70799255371094 204.11500549316406,210.70799255371094 C214.33200073242188,210.70799255371094 222.61500549316406,202.4250030517578 222.61500549316406,192.20799255371094 C222.61500549316406,181.99099731445312 214.33200073242188,173.70799255371094 204.11500549316406,173.70799255371094z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,886,589.5)",
    opacity: 1,
    style: {
      display: "block"
    }
  }, _g129 || (_g129 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    fillOpacity: 0,
    strokeMiterlimit: 4,
    stroke: "rgb(49,117,209)",
    strokeOpacity: 1,
    strokeWidth: 2,
    d: " M-220.63681030273438,-49.557647705078125 C-220.63681030273438,-49.557647705078125 -304.9095458984375,100.9434585571289 -304.9095458984375,100.9434585571289"
  }))), _g130 || (_g130 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    fillOpacity: 0,
    strokeMiterlimit: 4,
    stroke: "rgb(49,117,209)",
    strokeOpacity: 1,
    strokeWidth: 2,
    d: " M-147.86651611328125,-209.92527770996094 C-147.86651611328125,-209.92527770996094 -219.75897216796875,-50.057647705078125 -219.75897216796875,-50.057647705078125"
  }))), _g131 || (_g131 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    fillOpacity: 0,
    strokeMiterlimit: 4,
    stroke: "rgb(49,117,209)",
    strokeOpacity: 1,
    strokeWidth: 2,
    d: " M-220.00332641601562,-50.1798210144043 C-220.00332641601562,-50.1798210144043 -186.9751739501953,-33.490909576416016 -186.9751739501953,-33.490909576416016"
  }))), _g132 || (_g132 = /*#__PURE__*/React.createElement("g", {
    opacity: 0,
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    fillOpacity: 0,
    strokeMiterlimit: 4,
    stroke: "rgb(49,117,209)",
    strokeOpacity: 1,
    strokeWidth: 2,
    d: " M-195.35533142089844,-149.92189025878906 C-195.35533142089844,-149.92189025878906 -285.1042175292969,27.18780517578125 -285.1042175292969,27.18780517578125"
  }))), _g133 || (_g133 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    fillOpacity: 0,
    strokeMiterlimit: 4,
    stroke: "rgb(49,117,209)",
    strokeOpacity: 1,
    strokeWidth: 2,
    d: " M-305.9095458984375,100.4434585571289 C-305.9095458984375,100.4434585571289 -186.9751739501953,-33.490909576416016 -186.9751739501953,-33.490909576416016"
  }))), _g134 || (_g134 = /*#__PURE__*/React.createElement("g", {
    opacity: 0,
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    fillOpacity: 0,
    strokeMiterlimit: 4,
    stroke: "rgb(49,117,209)",
    strokeOpacity: 1,
    strokeWidth: 2,
    d: " M-286.1042175292969,27.18780517578125 C-286.1042175292969,27.18780517578125 -186.9751739501953,-33.490909576416016 -186.9751739501953,-33.490909576416016"
  }))), _g135 || (_g135 = /*#__PURE__*/React.createElement("g", {
    opacity: 0,
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    fillOpacity: 0,
    strokeMiterlimit: 4,
    stroke: "rgb(49,117,209)",
    strokeOpacity: 1,
    strokeWidth: 2,
    d: " M-285.3542175292969,27.56280517578125 C-285.3542175292969,27.56280517578125 -306.2845458984375,100.3184585571289 -306.2845458984375,100.3184585571289"
  }))), _g136 || (_g136 = /*#__PURE__*/React.createElement("g", {
    opacity: 0,
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    fillOpacity: 0,
    strokeMiterlimit: 4,
    stroke: "rgb(49,117,209)",
    strokeOpacity: 1,
    strokeWidth: 2,
    d: " M-285.3542175292969,27.56280517578125 C-285.3542175292969,27.56280517578125 -453.5753479003906,129.6419677734375 -453.5753479003906,129.6419677734375"
  }))), _g137 || (_g137 = /*#__PURE__*/React.createElement("g", {
    opacity: 0,
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    fillOpacity: 0,
    strokeMiterlimit: 4,
    stroke: "rgb(49,117,209)",
    strokeOpacity: 1,
    strokeWidth: 2,
    d: " M-306.1595458984375,99.3184585571289 C-306.1595458984375,99.3184585571289 -453.0753479003906,129.6419677734375 -453.0753479003906,129.6419677734375"
  }))), _g138 || (_g138 = /*#__PURE__*/React.createElement("g", {
    opacity: 0,
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    fillOpacity: 0,
    strokeMiterlimit: 4,
    stroke: "rgb(49,117,209)",
    strokeOpacity: 1,
    strokeWidth: 2,
    d: " M-194.85533142089844,-150.42189025878906 C-194.85533142089844,-150.42189025878906 -186.9751739501953,-33.490909576416016 -186.9751739501953,-33.490909576416016"
  }))), _g139 || (_g139 = /*#__PURE__*/React.createElement("g", {
    opacity: 0,
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    fillOpacity: 0,
    strokeMiterlimit: 4,
    stroke: "rgb(49,117,209)",
    strokeOpacity: 1,
    strokeWidth: 2,
    d: " M-148.36651611328125,-208.92527770996094 C-148.36651611328125,-208.92527770996094 -194.85533142089844,-149.42189025878906 -194.85533142089844,-149.42189025878906"
  }))), _g140 || (_g140 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,-223,-88.5)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    fillOpacity: 0,
    strokeMiterlimit: 4,
    stroke: "rgb(49,117,209)",
    strokeOpacity: 1,
    strokeWidth: 2,
    d: " M74.13348388671875,-120.42527770996094 C74.13348388671875,-120.42527770996094 36.02483367919922,55.009090423583984 36.02483367919922,55.009090423583984"
  }))), _g141 || (_g141 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,-223,-88.5)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "rgb(49,117,209)",
    fillOpacity: 1,
    d: " M35.52483367919922,48.009090423583984 C39.666831970214844,48.009090423583984 43.02483367919922,51.36709213256836 43.02483367919922,55.509090423583984 C43.02483367919922,59.651092529296875 39.666831970214844,63.009090423583984 35.52483367919922,63.009090423583984 C31.382831573486328,63.009090423583984 28.024831771850586,59.651092529296875 28.024831771850586,55.509090423583984 C28.024831771850586,51.36709213256836 31.382831573486328,48.009090423583984 35.52483367919922,48.009090423583984z"
  }))), _g142 || (_g142 = /*#__PURE__*/React.createElement("g", {
    opacity: 0,
    transform: "matrix(1,0,0,1,-223,-88.5)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "rgb(49,117,209)",
    fillOpacity: 1,
    d: " M-62.604217529296875,108.68780517578125 C-58.462215423583984,108.68780517578125 -55.104217529296875,112.04580688476562 -55.104217529296875,116.18780517578125 C-55.104217529296875,120.32980346679688 -58.462215423583984,123.68780517578125 -62.604217529296875,123.68780517578125 C-66.7462158203125,123.68780517578125 -70.10421752929688,120.32980346679688 -70.10421752929688,116.18780517578125 C-70.10421752929688,112.04580688476562 -66.7462158203125,108.68780517578125 -62.604217529296875,108.68780517578125z"
  }))), _g143 || (_g143 = /*#__PURE__*/React.createElement("g", {
    opacity: 0,
    transform: "matrix(1,0,0,1,-223,-88.5)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "rgb(49,117,209)",
    fillOpacity: 1,
    d: " M27.894676208496094,-69.9218978881836 C32.03667449951172,-69.9218978881836 35.394676208496094,-66.56389617919922 35.394676208496094,-62.42189407348633 C35.394676208496094,-58.2798957824707 32.03667449951172,-54.92189407348633 27.894676208496094,-54.92189407348633 C23.752676010131836,-54.92189407348633 20.394676208496094,-58.2798957824707 20.394676208496094,-62.42189407348633 C20.394676208496094,-66.56389617919922 23.752676010131836,-69.9218978881836 27.894676208496094,-69.9218978881836z"
  }))), _g144 || (_g144 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,-223,-88.5)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "rgb(49,117,209)",
    fillOpacity: 1,
    d: " M73.88348388671875,-128.42527770996094 C78.02548217773438,-128.42527770996094 81.38348388671875,-125.06727600097656 81.38348388671875,-120.92527770996094 C81.38348388671875,-116.78327941894531 78.02548217773438,-113.42527770996094 73.88348388671875,-113.42527770996094 C69.7414779663086,-113.42527770996094 66.38348388671875,-116.78327941894531 66.38348388671875,-120.92527770996094 C66.38348388671875,-125.06727600097656 69.7414779663086,-128.42527770996094 73.88348388671875,-128.42527770996094z"
  }))), _g145 || (_g145 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,-223,-88.5)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "rgb(49,117,209)",
    fillOpacity: 1,
    d: " M-82.40953826904297,181.44346618652344 C-78.26753234863281,181.44346618652344 -74.90953826904297,184.80145263671875 -74.90953826904297,188.94346618652344 C-74.90953826904297,193.08546447753906 -78.26753234863281,196.44346618652344 -82.40953826904297,196.44346618652344 C-86.5515365600586,196.44346618652344 -89.90953826904297,193.08546447753906 -89.90953826904297,188.94346618652344 C-89.90953826904297,184.80145263671875 -86.5515365600586,181.44346618652344 -82.40953826904297,181.44346618652344z"
  }))), _g146 || (_g146 = /*#__PURE__*/React.createElement("g", {
    opacity: 0,
    transform: "matrix(1,0,0,1,-223,-88.5)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "rgb(49,117,209)",
    fillOpacity: 1,
    d: " M-230.95033264160156,210.2669677734375 C-226.80833435058594,210.2669677734375 -223.45033264160156,213.62496948242188 -223.45033264160156,217.7669677734375 C-223.45033264160156,221.90896606445312 -226.80833435058594,225.2669677734375 -230.95033264160156,225.2669677734375 C-235.0923309326172,225.2669677734375 -238.45033264160156,221.90896606445312 -238.45033264160156,217.7669677734375 C-238.45033264160156,213.62496948242188 -235.0923309326172,210.2669677734375 -230.95033264160156,210.2669677734375z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,623,376)",
    opacity: 1,
    style: {
      display: "block"
    }
  }, _g147 || (_g147 = /*#__PURE__*/React.createElement("g", {
    opacity: 0,
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    fillOpacity: 0,
    strokeMiterlimit: 4,
    stroke: "rgb(49,117,209)",
    strokeOpacity: 1,
    strokeWidth: 2,
    d: " M-100.98466491699219,-198.81219482421875 C-100.98466491699219,-198.81219482421875 -68.85742950439453,-277.07391357421875 -68.85742950439453,-277.07391357421875"
  }))), _g148 || (_g148 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    fillOpacity: 0,
    strokeMiterlimit: 4,
    stroke: "rgb(49,117,209)",
    strokeOpacity: 1,
    strokeWidth: 2,
    d: " M-69.60742950439453,-274.74090576171875 C-69.60742950439453,-274.74090576171875 48.43558883666992,-169.8087615966797 48.43558883666992,-169.8087615966797"
  }))), _g149 || (_g149 = /*#__PURE__*/React.createElement("g", {
    opacity: 0,
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    fillOpacity: 0,
    strokeMiterlimit: 4,
    stroke: "rgb(49,117,209)",
    strokeOpacity: 1,
    strokeWidth: 2,
    d: " M114.47765350341797,4.835897445678711 C114.47765350341797,4.835897445678711 51.835350036621094,-130.51931762695312 51.835350036621094,-130.51931762695312"
  }))), _g150 || (_g150 = /*#__PURE__*/React.createElement("g", {
    opacity: 0,
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    fillOpacity: 0,
    strokeMiterlimit: 4,
    stroke: "rgb(49,117,209)",
    strokeOpacity: 1,
    strokeWidth: 2,
    d: " M48.68558883666992,-170.8087615966797 C48.68558883666992,-170.8087615966797 52.47235107421875,-130.51332092285156 52.47235107421875,-130.51332092285156"
  }))), _g151 || (_g151 = /*#__PURE__*/React.createElement("g", {
    opacity: 0,
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    fillOpacity: 0,
    strokeMiterlimit: 4,
    stroke: "rgb(49,117,209)",
    strokeOpacity: 1,
    strokeWidth: 2,
    d: " M66.86711120605469,64.78130340576172 C66.86711120605469,64.78130340576172 52.47434997558594,-129.99131774902344 52.47434997558594,-129.99131774902344"
  }))), _g152 || (_g152 = /*#__PURE__*/React.createElement("g", {
    opacity: 0,
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    fillOpacity: 0,
    strokeMiterlimit: 4,
    stroke: "rgb(49,117,209)",
    strokeOpacity: 1,
    strokeWidth: 2,
    d: " M52.64134979248047,-129.90830993652344 C52.64134979248047,-129.90830993652344 -68.85742950439453,-275.99090576171875 -68.85742950439453,-275.99090576171875"
  }))), _g153 || (_g153 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    fillOpacity: 0,
    strokeMiterlimit: 4,
    stroke: "rgb(49,117,209)",
    strokeOpacity: 1,
    strokeWidth: 2,
    d: " M-69.85742950439453,-274.74090576171875 C-69.85742950439453,-274.74090576171875 -92.83015441894531,-242.47959899902344 -92.83015441894531,-242.47959899902344"
  }))), _g154 || (_g154 = /*#__PURE__*/React.createElement("g", {
    opacity: 0,
    transform: "matrix(1,0,0,1,22,-204.5)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    fillOpacity: 0,
    strokeMiterlimit: 4,
    stroke: "rgb(49,117,209)",
    strokeOpacity: 1,
    strokeWidth: 2,
    d: " M-123.73466491699219,5.520805358886719 C-123.73466491699219,5.520805358886719 30.72435188293457,73.7586898803711 30.72435188293457,73.7586898803711 C30.72435188293457,73.7586898803711 -123.73466491699219,5.520805358886719 -123.73466491699219,5.520805358886719"
  }))), _g155 || (_g155 = /*#__PURE__*/React.createElement("g", {
    opacity: 0,
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    fillOpacity: 0,
    strokeMiterlimit: 4,
    stroke: "rgb(49,117,209)",
    strokeOpacity: 1,
    strokeWidth: 2,
    d: " M32,-195.5 C32,-195.5 70.25,-108.25 70.25,-108.25"
  }))), _g156 || (_g156 = /*#__PURE__*/React.createElement("g", {
    opacity: 0,
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    fillOpacity: 0,
    strokeMiterlimit: 4,
    stroke: "rgb(49,117,209)",
    strokeOpacity: 1,
    strokeWidth: 2,
    d: " M70,-108.75 C70,-108.75 113,-6.75 113,-6.75"
  }))), _g157 || (_g157 = /*#__PURE__*/React.createElement("g", {
    opacity: 0,
    transform: "matrix(1,0,0,1,22,-204.5)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "rgb(49,117,209)",
    fillOpacity: 1,
    d: " M30.3913516998291,66.34169006347656 C34.53335189819336,66.34169006347656 37.89134979248047,69.6996841430664 37.89134979248047,73.84169006347656 C37.89134979248047,77.98368835449219 34.53335189819336,81.34169006347656 30.3913516998291,81.34169006347656 C26.249351501464844,81.34169006347656 22.8913516998291,77.98368835449219 22.8913516998291,73.84169006347656 C22.8913516998291,69.6996841430664 26.249351501464844,66.34169006347656 30.3913516998291,66.34169006347656z"
  }))), _g158 || (_g158 = /*#__PURE__*/React.createElement("g", {
    opacity: 0,
    transform: "matrix(1,0,0,1,22,-204.5)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "rgb(49,117,209)",
    fillOpacity: 1,
    d: " M-123.90166473388672,-2.062194585800171 C-119.7596664428711,-2.062194585800171 -116.40166473388672,1.2958054542541504 -116.40166473388672,5.43780517578125 C-116.40166473388672,9.579805374145508 -119.7596664428711,12.93780517578125 -123.90166473388672,12.93780517578125 C-128.04367065429688,12.93780517578125 -131.40167236328125,9.579805374145508 -131.40167236328125,5.43780517578125 C-131.40167236328125,1.2958054542541504 -128.04367065429688,-2.062194585800171 -123.90166473388672,-2.062194585800171z"
  }))), _g159 || (_g159 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,22,-204.5)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "rgb(49,117,209)",
    fillOpacity: 1,
    d: " M-90.60742950439453,-78.74090576171875 C-86.46542358398438,-78.74090576171875 -83.10742950439453,-75.3829116821289 -83.10742950439453,-71.24090576171875 C-83.10742950439453,-67.09890747070312 -86.46542358398438,-63.740909576416016 -90.60742950439453,-63.740909576416016 C-94.74942779541016,-63.740909576416016 -98.10742950439453,-67.09890747070312 -98.10742950439453,-71.24090576171875 C-98.10742950439453,-75.3829116821289 -94.74942779541016,-78.74090576171875 -90.60742950439453,-78.74090576171875z"
  }))), _g160 || (_g160 = /*#__PURE__*/React.createElement("g", {
    opacity: 0,
    transform: "matrix(1,0,0,1,22,-204.5)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "rgb(49,117,209)",
    fillOpacity: 1,
    d: " M47.5,88.5 C51.641998291015625,88.5 55,91.85800170898438 55,96 C55,100.14199829101562 51.641998291015625,103.5 47.5,103.5 C43.358001708984375,103.5 40,100.14199829101562 40,96 C40,91.85800170898438 43.358001708984375,88.5 47.5,88.5z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,398.5,400)",
    opacity: 1,
    style: {
      display: "block"
    }
  }, _g161 || (_g161 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    fillOpacity: 0,
    strokeMiterlimit: 4,
    stroke: "rgb(49,117,209)",
    strokeOpacity: 1,
    strokeWidth: 2,
    d: " M-321.6312561035156,18.303102493286133 C-321.6312561035156,18.303102493286133 -316.4818115234375,-44.830379486083984 -316.4818115234375,-44.830379486083984"
  }))), _g162 || (_g162 = /*#__PURE__*/React.createElement("g", {
    opacity: 0,
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    fillOpacity: 0,
    strokeMiterlimit: 4,
    stroke: "rgb(49,117,209)",
    strokeOpacity: 1,
    strokeWidth: 2,
    d: " M-322.1312561035156,18.803102493286133 C-322.1312561035156,18.803102493286133 -297.5565490722656,-153.1855926513672 -297.5565490722656,-153.1855926513672"
  }))), _g163 || (_g163 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    fillOpacity: 0,
    strokeMiterlimit: 4,
    stroke: "rgb(49,117,209)",
    strokeOpacity: 1,
    strokeWidth: 2,
    d: " M-295.0565490722656,-152.6855926513672 C-295.0565490722656,-152.6855926513672 -217.106201171875,-240.3643035888672 -217.106201171875,-240.3643035888672"
  }))), _g164 || (_g164 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    fillOpacity: 0,
    strokeMiterlimit: 4,
    stroke: "rgb(49,117,209)",
    strokeOpacity: 1,
    strokeWidth: 2,
    d: " M-218.606201171875,-239.1143035888672 C-218.606201171875,-239.1143035888672 -181.47433471679688,-96.16519165039062 -181.47433471679688,-96.16519165039062"
  }))), _g165 || (_g165 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    fillOpacity: 0,
    strokeMiterlimit: 4,
    stroke: "rgb(49,117,209)",
    strokeOpacity: 1,
    strokeWidth: 2,
    d: " M-181.4113311767578,-94.91519165039062 C-181.4113311767578,-94.91519165039062 -238.45777893066406,94.2352523803711 -238.45777893066406,94.2352523803711"
  }))), _g166 || (_g166 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    fillOpacity: 0,
    strokeMiterlimit: 4,
    stroke: "rgb(49,117,209)",
    strokeOpacity: 1,
    strokeWidth: 2,
    d: " M-239.39578247070312,93.4852523803711 C-239.39578247070312,93.4852523803711 -291.10723876953125,164.99090576171875 -291.10723876953125,164.99090576171875"
  }))), _g167 || (_g167 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    fillOpacity: 0,
    strokeMiterlimit: 4,
    stroke: "rgb(49,117,209)",
    strokeOpacity: 1,
    strokeWidth: 2,
    d: " M-290.04522705078125,164.36590576171875 C-290.04522705078125,164.36590576171875 -322.1932678222656,18.303102493286133 -322.1932678222656,18.303102493286133"
  }))), _g168 || (_g168 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    fillOpacity: 0,
    strokeMiterlimit: 4,
    stroke: "rgb(49,117,209)",
    strokeOpacity: 1,
    strokeWidth: 2,
    d: " M-35.566627502441406,-336.9943542480469 C-35.566627502441406,-336.9943542480469 -218.168212890625,-238.3643035888672 -218.168212890625,-238.3643035888672"
  }))), _g169 || (_g169 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    fillOpacity: 0,
    strokeMiterlimit: 4,
    stroke: "rgb(49,117,209)",
    strokeOpacity: 1,
    strokeWidth: 2,
    d: " M-170.30653381347656,-274.2477722167969 C-170.30653381347656,-274.2477722167969 -218.668212890625,-238.3643035888672 -218.668212890625,-238.3643035888672"
  }))), _g170 || (_g170 = /*#__PURE__*/React.createElement("g", {
    opacity: 0,
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    fillOpacity: 0,
    strokeMiterlimit: 4,
    stroke: "rgb(49,117,209)",
    strokeOpacity: 1,
    strokeWidth: 2,
    d: " M-170.30653381347656,-274.2477722167969 C-170.30653381347656,-274.2477722167969 -295.1185302734375,-153.6855926513672 -295.1185302734375,-153.6855926513672"
  }))), _g171 || (_g171 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    fillOpacity: 0,
    strokeMiterlimit: 4,
    stroke: "rgb(49,117,209)",
    strokeOpacity: 1,
    strokeWidth: 2,
    d: " M-179.5,-99"
  }))), _g172 || (_g172 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    fillOpacity: 0,
    strokeMiterlimit: 4,
    stroke: "rgb(49,117,209)",
    strokeOpacity: 1,
    strokeWidth: 2,
    d: " M-289.623291015625,163.74656677246094 C-289.623291015625,163.74656677246094 -316.4818115234375,-44.830379486083984 -316.4818115234375,-44.830379486083984"
  }))), _g173 || (_g173 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    fillOpacity: 0,
    strokeMiterlimit: 4,
    stroke: "rgb(49,117,209)",
    strokeOpacity: 1,
    strokeWidth: 2,
    d: " M-238.89578247070312,94.2352523803711 C-238.89578247070312,94.2352523803711 -316.4818115234375,-44.830379486083984 -316.4818115234375,-44.830379486083984"
  }))), _g174 || (_g174 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    fillOpacity: 0,
    strokeMiterlimit: 4,
    stroke: "rgb(49,117,209)",
    strokeOpacity: 1,
    strokeWidth: 2,
    d: " M-59.82106018066406,102.02261352539062 C-59.82106018066406,102.02261352539062 -239.89578247070312,94.2352523803711 -239.89578247070312,94.2352523803711"
  }))), _g175 || (_g175 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    fillOpacity: 0,
    strokeMiterlimit: 4,
    stroke: "rgb(49,117,209)",
    strokeOpacity: 1,
    strokeWidth: 2,
    d: " M-136.9818115234375,262.7895812988281 C-136.9818115234375,262.7895812988281 -239.27078247070312,94.6102523803711 -239.27078247070312,94.6102523803711"
  }))), _g176 || (_g176 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    fillOpacity: 0,
    strokeMiterlimit: 4,
    stroke: "rgb(49,117,209)",
    strokeOpacity: 1,
    strokeWidth: 2,
    d: " M-137.6068115234375,260.4145812988281 C-137.6068115234375,260.4145812988281 -289.42022705078125,164.86590576171875 -289.42022705078125,164.86590576171875"
  }))), _g177 || (_g177 = /*#__PURE__*/React.createElement("g", {
    opacity: 0,
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    fillOpacity: 0,
    strokeMiterlimit: 4,
    stroke: "rgb(49,117,209)",
    strokeOpacity: 1,
    strokeWidth: 2,
    d: " M-286.2200012207031,155.2740020751953 C-286.2200012207031,155.2740020751953 -270.61700439453125,174.48899841308594 -270.61700439453125,174.48899841308594"
  }))), _g178 || (_g178 = /*#__PURE__*/React.createElement("g", {
    opacity: 0,
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    fillOpacity: 0,
    strokeMiterlimit: 4,
    stroke: "rgb(49,117,209)",
    strokeOpacity: 1,
    strokeWidth: 2,
    d: " M-290.6529846191406,165.9044189453125 C-290.6529846191406,165.9044189453125 -321.75640869140625,18.928266525268555 -321.75640869140625,18.928266525268555"
  }))), _g179 || (_g179 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    fillOpacity: 0,
    strokeMiterlimit: 4,
    stroke: "rgb(49,117,209)",
    strokeOpacity: 1,
    strokeWidth: 2,
    d: " M-179.9113311767578,-95.66519165039062 C-179.9113311767578,-95.66519165039062 -316.4818115234375,-44.830379486083984 -316.4818115234375,-44.830379486083984"
  }))), _g180 || (_g180 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    fillOpacity: 0,
    strokeMiterlimit: 4,
    stroke: "rgb(49,117,209)",
    strokeOpacity: 1,
    strokeWidth: 2,
    d: " M-218.356201171875,-238.8643035888672 C-218.356201171875,-238.8643035888672 -316.4818115234375,-44.830379486083984 -316.4818115234375,-44.830379486083984"
  }))), _g181 || (_g181 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,-223,-88.5)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    fillOpacity: 0,
    strokeMiterlimit: 4,
    stroke: "rgb(49,117,209)",
    strokeOpacity: 1,
    strokeWidth: 2,
    d: " M-72.0565414428711,-65.68559265136719 C-72.0565414428711,-65.68559265136719 -92.48181915283203,44.669620513916016 -92.48181915283203,44.669620513916016"
  }))), _g182 || (_g182 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,-223,-88.5)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "rgb(49,117,209)",
    fillOpacity: 1,
    d: " M-93.98181915283203,36.669620513916016 C-89.83981323242188,36.669620513916016 -86.48181915283203,40.02762222290039 -86.48181915283203,44.169620513916016 C-86.48181915283203,48.311622619628906 -89.83981323242188,51.669620513916016 -93.98181915283203,51.669620513916016 C-98.12381744384766,51.669620513916016 -101.48181915283203,48.311622619628906 -101.48181915283203,44.169620513916016 C-101.48181915283203,40.02762222290039 -98.12381744384766,36.669620513916016 -93.98181915283203,36.669620513916016z"
  }))), _g183 || (_g183 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,-223,-88.5)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "rgb(49,117,209)",
    fillOpacity: 1,
    d: " M-16.395784378051758,174.73526000976562 C-12.2537841796875,174.73526000976562 -8.895783424377441,178.09324645996094 -8.895783424377441,182.23526000976562 C-8.895783424377441,186.37725830078125 -12.2537841796875,189.73526000976562 -16.395784378051758,189.73526000976562 C-20.537784576416016,189.73526000976562 -23.895784378051758,186.37725830078125 -23.895784378051758,182.23526000976562 C-23.895784378051758,178.09324645996094 -20.537784576416016,174.73526000976562 -16.395784378051758,174.73526000976562z"
  }))), _g184 || (_g184 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,-223,-88.5)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "rgb(49,117,209)",
    fillOpacity: 1,
    d: " M-67.04523468017578,244.99090576171875 C-62.90323257446289,244.99090576171875 -59.545230865478516,248.34890747070312 -59.545230865478516,252.49090576171875 C-59.545230865478516,256.6329040527344 -62.90323257446289,259.99090576171875 -67.04523468017578,259.99090576171875 C-71.1872329711914,259.99090576171875 -74.54523468017578,256.6329040527344 -74.54523468017578,252.49090576171875 C-74.54523468017578,248.34890747070312 -71.1872329711914,244.99090576171875 -67.04523468017578,244.99090576171875z"
  }))), _g185 || (_g185 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,-223,-88.5)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "rgb(49,117,209)",
    fillOpacity: 1,
    d: " M-72.0565414428711,-72.43559265136719 C-67.91454315185547,-72.43559265136719 -64.5565414428711,-69.07759094238281 -64.5565414428711,-64.93559265136719 C-64.5565414428711,-60.7935905456543 -67.91454315185547,-57.43558883666992 -72.0565414428711,-57.43558883666992 C-76.19853973388672,-57.43558883666992 -79.5565414428711,-60.7935905456543 -79.5565414428711,-64.93559265136719 C-79.5565414428711,-69.07759094238281 -76.19853973388672,-72.43559265136719 -72.0565414428711,-72.43559265136719z"
  }))), _g186 || (_g186 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,-223,-88.5)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "rgb(49,117,209)",
    fillOpacity: 1,
    d: " M-98.63126373291016,100.3031005859375 C-94.48926544189453,100.3031005859375 -91.13126373291016,103.66110229492188 -91.13126373291016,107.8031005859375 C-91.13126373291016,111.94510650634766 -94.48926544189453,115.3031005859375 -98.63126373291016,115.3031005859375 C-102.77326202392578,115.3031005859375 -106.13126373291016,111.94510650634766 -106.13126373291016,107.8031005859375 C-106.13126373291016,103.66110229492188 -102.77326202392578,100.3031005859375 -98.63126373291016,100.3031005859375z"
  }))), _g187 || (_g187 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,-223,-88.5)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "rgb(49,117,209)",
    fillOpacity: 1,
    d: " M5.393794536590576,-158.3643035888672 C9.535794258117676,-158.3643035888672 12.893795013427734,-155.0063018798828 12.893795013427734,-150.8643035888672 C12.893795013427734,-146.72230529785156 9.535794258117676,-143.3643035888672 5.393794536590576,-143.3643035888672 C1.2517945766448975,-143.3643035888672 -2.106205463409424,-146.72230529785156 -2.106205463409424,-150.8643035888672 C-2.106205463409424,-155.0063018798828 1.2517945766448975,-158.3643035888672 5.393794536590576,-158.3643035888672z"
  }))), _g188 || (_g188 = /*#__PURE__*/React.createElement("g", {
    opacity: 0,
    transform: "matrix(1,0,0,1,-223,-88.5)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "rgb(49,117,209)",
    fillOpacity: 1,
    d: " M-29.602813720703125,263.99359130859375 C-25.460813522338867,263.99359130859375 -22.102813720703125,267.3515930175781 -22.102813720703125,271.49359130859375 C-22.102813720703125,275.6355895996094 -25.460813522338867,278.99359130859375 -29.602813720703125,278.99359130859375 C-33.744815826416016,278.99359130859375 -37.102813720703125,275.6355895996094 -37.102813720703125,271.49359130859375 C-37.102813720703125,267.3515930175781 -33.744815826416016,263.99359130859375 -29.602813720703125,263.99359130859375z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,623,376)",
    opacity: 1,
    style: {
      display: "block"
    }
  }, _g189 || (_g189 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    fillOpacity: 0,
    strokeMiterlimit: 4,
    stroke: "rgb(49,117,209)",
    strokeOpacity: 1,
    strokeWidth: 2,
    d: " M49.807762145996094,-168.65830993652344 C49.807762145996094,-168.65830993652344 26.626832962036133,-53.39134979248047 26.626832962036133,-53.39134979248047"
  }))), _g190 || (_g190 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    fillOpacity: 0,
    strokeMiterlimit: 4,
    stroke: "rgb(49,117,209)",
    strokeOpacity: 1,
    strokeWidth: 2,
    d: " M114.76130676269531,4.569070339202881 C114.76130676269531,4.569070339202881 26.626832962036133,-53.39134979248047 26.626832962036133,-53.39134979248047"
  }))), _g191 || (_g191 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    fillOpacity: 0,
    strokeMiterlimit: 4,
    stroke: "rgb(49,117,209)",
    strokeOpacity: 1,
    strokeWidth: 2,
    d: " M-79.00321197509766,99.92649841308594 C-79.00321197509766,99.92649841308594 26.626832962036133,-53.39134979248047 26.626832962036133,-53.39134979248047"
  }))), _g192 || (_g192 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    fillOpacity: 0,
    strokeMiterlimit: 4,
    stroke: "rgb(49,117,209)",
    strokeOpacity: 1,
    strokeWidth: 2,
    d: " M44.179935455322266,162.8756103515625 C44.179935455322266,162.8756103515625 26.626832962036133,-53.39134979248047 26.626832962036133,-53.39134979248047"
  }))), _g193 || (_g193 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    fillOpacity: 0,
    strokeMiterlimit: 4,
    stroke: "rgb(49,117,209)",
    strokeOpacity: 1,
    strokeWidth: 2,
    d: " M49.557762145996094,-170.15830993652344 C49.557762145996094,-170.15830993652344 115.76130676269531,5.569070339202881 115.76130676269531,5.569070339202881"
  }))), _g194 || (_g194 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    fillOpacity: 0,
    strokeMiterlimit: 4,
    stroke: "rgb(49,117,209)",
    strokeOpacity: 1,
    strokeWidth: 2,
    d: " M49.557762145996094,-170.15830993652344 C49.557762145996094,-170.15830993652344 -91.45232391357422,-240.857421875 -91.45232391357422,-240.857421875"
  }))), _g195 || (_g195 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    fillOpacity: 0,
    strokeMiterlimit: 4,
    stroke: "rgb(49,117,209)",
    strokeOpacity: 1,
    strokeWidth: 2,
    d: " M-92.45232391357422,-241.857421875 C-92.45232391357422,-241.857421875 26.626832962036133,-53.39134979248047 26.626832962036133,-53.39134979248047"
  }))), _g196 || (_g196 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,-223,-88.5)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "rgb(49,117,209)",
    fillOpacity: 1,
    d: " M249.1268310546875,28.1086483001709 C253.26882934570312,28.1086483001709 256.6268310546875,31.46664810180664 256.6268310546875,35.60865020751953 C256.6268310546875,39.750648498535156 253.26882934570312,43.10865020751953 249.1268310546875,43.10865020751953 C244.98483276367188,43.10865020751953 241.6268310546875,39.750648498535156 241.6268310546875,35.60865020751953 C241.6268310546875,31.46664810180664 244.98483276367188,28.1086483001709 249.1268310546875,28.1086483001709z"
  }))), _g197 || (_g197 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,-223,-88.5)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "rgb(49,117,209)",
    fillOpacity: 1,
    d: " M272.3077697753906,-89.15830993652344 C276.44976806640625,-89.15830993652344 279.8077697753906,-85.8003158569336 279.8077697753906,-81.65830993652344 C279.8077697753906,-77.51631164550781 276.44976806640625,-74.15830993652344 272.3077697753906,-74.15830993652344 C268.165771484375,-74.15830993652344 264.8077697753906,-77.51631164550781 264.8077697753906,-81.65830993652344 C264.8077697753906,-85.8003158569336 268.165771484375,-89.15830993652344 272.3077697753906,-89.15830993652344z"
  }))), _g198 || (_g198 = /*#__PURE__*/React.createElement("g", {
    opacity: 0,
    transform: "matrix(0.7544432282447815,0,0,0.791572630405426,-241,-290.5)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "rgb(49,117,209)",
    fillOpacity: 1,
    d: " M-212.758544921875,733.2489624023438 C-222.9755401611328,733.2489624023438 -231.258544921875,741.531494140625 -231.258544921875,751.7484741210938 C-231.258544921875,761.9655151367188 -222.9755401611328,770.2484741210938 -212.758544921875,770.2484741210938 C-202.54153442382812,770.2484741210938 -194.258544921875,761.9655151367188 -194.258544921875,751.7484741210938 C-194.258544921875,741.531494140625 -202.54153442382812,733.2489624023438 -212.758544921875,733.2489624023438z"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    fillOpacity: 0,
    strokeMiterlimit: 4,
    stroke: "rgb(49,117,209)",
    strokeOpacity: 1,
    strokeWidth: 0,
    d: " M-212.758544921875,733.2489624023438 C-222.9755401611328,733.2489624023438 -231.258544921875,741.531494140625 -231.258544921875,751.7484741210938 C-231.258544921875,761.9655151367188 -222.9755401611328,770.2484741210938 -212.758544921875,770.2484741210938 C-202.54153442382812,770.2484741210938 -194.258544921875,761.9655151367188 -194.258544921875,751.7484741210938 C-194.258544921875,741.531494140625 -202.54153442382812,733.2489624023438 -212.758544921875,733.2489624023438z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,400,400)",
    opacity: 1,
    style: {
      display: "block"
    }
  }, _g199 || (_g199 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    fillOpacity: 0,
    strokeMiterlimit: 4,
    stroke: "rgb(49,117,209)",
    strokeOpacity: 1,
    strokeWidth: 2,
    d: " M-64.33236694335938,-253.2330322265625 C-64.33236694335938,-253.2330322265625 45.71064758300781,-109.92305755615234 45.71064758300781,-109.92305755615234"
  }))), _g200 || (_g200 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    fillOpacity: 0,
    strokeMiterlimit: 4,
    stroke: "rgb(49,117,209)",
    strokeOpacity: 1,
    strokeWidth: 2,
    d: " M-181.21018981933594,-95.78736114501953 C-181.21018981933594,-95.78736114501953 45.71064758300781,-109.92305755615234 45.71064758300781,-109.92305755615234"
  }))), _g201 || (_g201 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    fillOpacity: 0,
    strokeMiterlimit: 4,
    stroke: "rgb(49,117,209)",
    strokeOpacity: 1,
    strokeWidth: 2,
    d: " M-61.78351974487305,100.58129119873047 C-61.78351974487305,100.58129119873047 -181.9481964111328,-95.94377899169922 -181.9481964111328,-95.94377899169922"
  }))), _g202 || (_g202 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    fillOpacity: 0,
    strokeMiterlimit: 4,
    stroke: "rgb(49,117,209)",
    strokeOpacity: 1,
    strokeWidth: 2,
    d: " M-181.4481964111328,-96.6994400024414 C-181.4481964111328,-96.6994400024414 -64.1578140258789,-253.98971557617188 -64.1578140258789,-253.98971557617188"
  }))), _g203 || (_g203 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    fillOpacity: 0,
    strokeMiterlimit: 4,
    stroke: "rgb(49,117,209)",
    strokeOpacity: 1,
    strokeWidth: 2,
    d: " M-61.69888687133789,101.02261352539062 C-61.69888687133789,101.02261352539062 45.71064758300781,-109.92305755615234 45.71064758300781,-109.92305755615234"
  }))), _g204 || (_g204 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    fillOpacity: 0,
    strokeMiterlimit: 4,
    stroke: "rgb(49,117,209)",
    strokeOpacity: 1,
    strokeWidth: 2,
    d: " M143.89157104492188,74.9434585571289 C143.89157104492188,74.9434585571289 45.71064758300781,-109.92305755615234 45.71064758300781,-109.92305755615234"
  }))), _g205 || (_g205 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    fillOpacity: 0,
    strokeMiterlimit: 4,
    stroke: "rgb(49,117,209)",
    strokeOpacity: 1,
    strokeWidth: 2,
    d: " M250.73770141601562,-76.39134979248047 C250.73770141601562,-76.39134979248047 45.71064758300781,-110.92305755615234 45.71064758300781,-110.92305755615234"
  }))), _g206 || (_g206 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    fillOpacity: 0,
    strokeMiterlimit: 4,
    stroke: "rgb(49,117,209)",
    strokeOpacity: 1,
    strokeWidth: 2,
    d: " M130.1698455810547,-265.4796142578125 C130.1698455810547,-265.4796142578125 45.71064758300781,-109.92305755615234 45.71064758300781,-109.92305755615234"
  }))), _g207 || (_g207 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,-223,-88.5)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "rgb(49,117,209)",
    fillOpacity: 1,
    d: " M268.2106628417969,-28.423059463500977 C272.3526611328125,-28.423059463500977 275.7106628417969,-25.065059661865234 275.7106628417969,-20.923059463500977 C275.7106628417969,-16.78105926513672 272.3526611328125,-13.423059463500977 268.2106628417969,-13.423059463500977 C264.0686340332031,-13.423059463500977 260.7106628417969,-16.78105926513672 260.7106628417969,-20.923059463500977 C260.7106628417969,-25.065059661865234 264.0686340332031,-28.423059463500977 268.2106628417969,-28.423059463500977z"
  }))), _g208 || (_g208 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "rgb(49,117,209)",
    fillOpacity: 1,
    d: " M-180.41819763183594,-102.66936492919922 C-176.2761993408203,-102.66936492919922 -172.91819763183594,-99.31136322021484 -172.91819763183594,-95.16936492919922 C-172.91819763183594,-91.02735900878906 -176.2761993408203,-87.66936492919922 -180.41819763183594,-87.66936492919922 C-184.56019592285156,-87.66936492919922 -187.91819763183594,-91.02735900878906 -187.91819763183594,-95.16936492919922 C-187.91819763183594,-99.31136322021484 -184.56019592285156,-102.66936492919922 -180.41819763183594,-102.66936492919922z"
  }))), _g209 || (_g209 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "rgb(49,117,209)",
    fillOpacity: 1,
    d: " M130.141845703125,-273.1736145019531 C134.28384399414062,-273.1736145019531 137.641845703125,-269.81561279296875 137.641845703125,-265.6736145019531 C137.641845703125,-261.5315856933594 134.28384399414062,-258.1736145019531 130.141845703125,-258.1736145019531 C125.99984741210938,-258.1736145019531 122.641845703125,-261.5315856933594 122.641845703125,-265.6736145019531 C122.641845703125,-269.81561279296875 125.99984741210938,-273.1736145019531 130.141845703125,-273.1736145019531z"
  }))), _g210 || (_g210 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "rgb(49,117,209)",
    fillOpacity: 1,
    d: " M-61.712318420410156,92.63496398925781 C-57.57032012939453,92.63496398925781 -54.212318420410156,95.99296569824219 -54.212318420410156,100.13496398925781 C-54.212318420410156,104.27696228027344 -57.57032012939453,107.63496398925781 -61.712318420410156,107.63496398925781 C-65.85431671142578,107.63496398925781 -69.21231842041016,104.27696228027344 -69.21231842041016,100.13496398925781 C-69.21231842041016,95.99296569824219 -65.85431671142578,92.63496398925781 -61.712318420410156,92.63496398925781z"
  }))), _g211 || (_g211 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.33443096774193687,
    transform: "matrix(0.9129592180252075,0,0,0.9392962455749512,-241,-290.5)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "rgb(49,117,209)",
    fillOpacity: 1,
    d: " M406.56634521484375,9.793505668640137 C397.13958740234375,9.793505668640137 389.4974060058594,17.435688018798828 389.4974060058594,26.862451553344727 C389.4974060058594,36.289215087890625 397.13958740234375,43.931396484375 406.56634521484375,43.931396484375 C415.99310302734375,43.931396484375 423.63427734375,36.289215087890625 423.63427734375,26.862451553344727 C423.63427734375,17.435688018798828 415.99310302734375,9.793505668640137 406.56634521484375,9.793505668640137z"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    fillOpacity: 0,
    strokeMiterlimit: 4,
    stroke: "rgb(49,117,209)",
    strokeOpacity: 1,
    strokeWidth: 1.6721548387096843,
    d: " M406.56634521484375,9.793505668640137 C397.13958740234375,9.793505668640137 389.4974060058594,17.435688018798828 389.4974060058594,26.862451553344727 C389.4974060058594,36.289215087890625 397.13958740234375,43.931396484375 406.56634521484375,43.931396484375 C415.99310302734375,43.931396484375 423.63427734375,36.289215087890625 423.63427734375,26.862451553344727 C423.63427734375,17.435688018798828 415.99310302734375,9.793505668640137 406.56634521484375,9.793505668640137z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,563,740)",
    opacity: 1,
    style: {
      display: "block"
    }
  }, _g212 || (_g212 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    fillOpacity: 0,
    strokeMiterlimit: 4,
    stroke: "rgb(49,117,209)",
    strokeOpacity: 1,
    strokeWidth: 2,
    d: " M-225.82106018066406,-239.86651611328125 C-225.82106018066406,-239.86651611328125 -301.84832763671875,-79.46607208251953 -301.84832763671875,-79.46607208251953"
  }))), _g213 || (_g213 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    fillOpacity: 0,
    strokeMiterlimit: 4,
    stroke: "rgb(49,117,209)",
    strokeOpacity: 1,
    strokeWidth: 2,
    d: " M-19.858421325683594,-265.06219482421875 C-19.858421325683594,-265.06219482421875 102.95255279541016,-201.1243896484375 102.95255279541016,-201.1243896484375"
  }))), _g214 || (_g214 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    fillOpacity: 0,
    strokeMiterlimit: 4,
    stroke: "rgb(49,117,209)",
    strokeOpacity: 1,
    strokeWidth: 2,
    d: " M-302.5592956542969,-80.40107727050781 C-302.5592956542969,-80.40107727050781 -164.30599975585938,-2.805999994277954 -164.30599975585938,-2.805999994277954"
  }))), _g215 || (_g215 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    fillOpacity: 0,
    strokeMiterlimit: 4,
    stroke: "rgb(49,117,209)",
    strokeOpacity: 1,
    strokeWidth: 2,
    d: " M-163.75,-4.5 C-163.75,-4.5 -82.66618347167969,-88.28958129882812 -82.66618347167969,-88.28958129882812"
  }))), _g216 || (_g216 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    fillOpacity: 0,
    strokeMiterlimit: 4,
    stroke: "rgb(49,117,209)",
    strokeOpacity: 1,
    strokeWidth: 2,
    d: " M-301.34832763671875,-83.46607208251953 C-301.34832763671875,-83.46607208251953 -82.91618347167969,-88.78958129882812 -82.91618347167969,-88.78958129882812"
  }))), _g217 || (_g217 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    fillOpacity: 0,
    strokeMiterlimit: 4,
    stroke: "rgb(49,117,209)",
    strokeOpacity: 1,
    strokeWidth: 2,
    d: " M-226.32106018066406,-240.99151611328125 C-226.32106018066406,-240.99151611328125 -82.91618347167969,-88.78958129882812 -82.91618347167969,-88.78958129882812"
  }))), _g218 || (_g218 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    fillOpacity: 0,
    strokeMiterlimit: 4,
    stroke: "rgb(49,117,209)",
    strokeOpacity: 1,
    strokeWidth: 2,
    d: " M-226.32106018066406,-240.74151611328125 C-226.32106018066406,-240.74151611328125 -27.525421142578125,-263.64520263671875 -27.525421142578125,-263.64520263671875"
  }))), _g219 || (_g219 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    fillOpacity: 0,
    strokeMiterlimit: 4,
    stroke: "rgb(49,117,209)",
    strokeOpacity: 1,
    strokeWidth: 2,
    d: " M16.084810256958008,-50.05088806152344 C16.084810256958008,-50.05088806152344 -82.91618347167969,-89.28958129882812 -82.91618347167969,-89.28958129882812"
  }))), _g220 || (_g220 = /*#__PURE__*/React.createElement("g", {
    opacity: 0,
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    fillOpacity: 0,
    strokeMiterlimit: 4,
    stroke: "rgb(49,117,209)",
    strokeOpacity: 1,
    strokeWidth: 2,
    d: " M-131.59512329101562,-21.244346618652344 C-131.59512329101562,-21.244346618652344 -163.5,-3 -163.5,-3"
  }))), _g221 || (_g221 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    fillOpacity: 0,
    strokeMiterlimit: 4,
    stroke: "rgb(49,117,209)",
    strokeOpacity: 1,
    strokeWidth: 2,
    d: " M105.20255279541016,-200.3743896484375 C105.20255279541016,-200.3743896484375 -82.91618347167969,-89.28958129882812 -82.91618347167969,-89.28958129882812"
  }))), _g222 || (_g222 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,-223,-88.5)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    fillOpacity: 0,
    strokeMiterlimit: 4,
    stroke: "rgb(49,117,209)",
    strokeOpacity: 1,
    strokeWidth: 2,
    d: " M203.64157104492188,-175.81219482421875 C203.64157104492188,-175.81219482421875 139.5838165283203,-0.289578378200531 139.5838165283203,-0.289578378200531"
  }))), _g223 || (_g223 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,-224.5,-91.5)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "rgb(49,117,209)",
    fillOpacity: 1,
    d: " M139.5838165283203,-7.789578437805176 C143.72581481933594,-7.789578437805176 147.0838165283203,-4.431578159332275 147.0838165283203,-0.289578378200531 C147.0838165283203,3.852421522140503 143.72581481933594,7.210421562194824 139.5838165283203,7.210421562194824 C135.4418182373047,7.210421562194824 132.0838165283203,3.852421522140503 132.0838165283203,-0.289578378200531 C132.0838165283203,-4.431578159332275 135.4418182373047,-7.789578437805176 139.5838165283203,-7.789578437805176z"
  }))), _g224 || (_g224 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,-225,-91)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "rgb(49,117,209)",
    fillOpacity: 1,
    d: " M60,80 C64.14199829101562,80 67.5,83.35800170898438 67.5,87.5 C67.5,91.64199829101562 64.14199829101562,95 60,95 C55.858001708984375,95 52.5,91.64199829101562 52.5,87.5 C52.5,83.35800170898438 55.858001708984375,80 60,80z"
  }))), _g225 || (_g225 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,-223,-88.5)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "rgb(49,117,209)",
    fillOpacity: 1,
    d: " M-78.84833526611328,1.0899243354797363 C-74.70633697509766,1.0899243354797363 -71.34833526611328,4.4479241371154785 -71.34833526611328,8.589923858642578 C-71.34833526611328,12.731924057006836 -74.70633697509766,16.089923858642578 -78.84833526611328,16.089923858642578 C-82.9903335571289,16.089923858642578 -86.34833526611328,12.731924057006836 -86.34833526611328,8.589923858642578 C-86.34833526611328,4.4479241371154785 -82.9903335571289,1.0899243354797363 -78.84833526611328,1.0899243354797363z"
  }))), _g226 || (_g226 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,-225,-87.5)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "rgb(49,117,209)",
    fillOpacity: 1,
    d: " M203.14157104492188,-183.81219482421875 C207.28358459472656,-183.81219482421875 210.64157104492188,-180.45419311523438 210.64157104492188,-176.31219482421875 C210.64157104492188,-172.17019653320312 207.28358459472656,-168.81219482421875 203.14157104492188,-168.81219482421875 C198.99957275390625,-168.81219482421875 195.64157104492188,-172.17019653320312 195.64157104492188,-176.31219482421875 C195.64157104492188,-180.45419311523438 198.99957275390625,-183.81219482421875 203.14157104492188,-183.81219482421875z"
  }))), _g227 || (_g227 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,-226,-87)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "rgb(49,117,209)",
    fillOpacity: 1,
    d: " M327.7025451660156,-119.8743896484375 C331.84454345703125,-119.8743896484375 335.2025451660156,-116.51638793945312 335.2025451660156,-112.3743896484375 C335.2025451660156,-108.23239135742188 331.84454345703125,-104.8743896484375 327.7025451660156,-104.8743896484375 C323.560546875,-104.8743896484375 320.2025451660156,-108.23239135742188 320.2025451660156,-112.3743896484375 C320.2025451660156,-116.51638793945312 323.560546875,-119.8743896484375 327.7025451660156,-119.8743896484375z"
  }))), _g228 || (_g228 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2260199999999987,
    transform: "matrix(0.9599999785423279,0,0,0.9599999785423279,-241,-290.5)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "rgb(49,117,209)",
    fillOpacity: 1,
    d: " M15.86544418334961,33.1606559753418 C5.648444175720215,33.1606559753418 -2.6345560550689697,41.44337463378906 -2.6345560550689697,51.66037368774414 C-2.6345560550689697,61.87737274169922 5.648444175720215,70.1603775024414 15.86544418334961,70.1603775024414 C26.082443237304688,70.1603775024414 34.36544418334961,61.87737274169922 34.36544418334961,51.66037368774414 C34.36544418334961,41.44337463378906 26.082443237304688,33.1606559753418 15.86544418334961,33.1606559753418z"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    fillOpacity: 0,
    strokeMiterlimit: 4,
    stroke: "rgb(49,117,209)",
    strokeOpacity: 1,
    strokeWidth: 1.1300999999999934,
    d: " M15.86544418334961,33.1606559753418 C5.648444175720215,33.1606559753418 -2.6345560550689697,41.44337463378906 -2.6345560550689697,51.66037368774414 C-2.6345560550689697,61.87737274169922 5.648444175720215,70.1603775024414 15.86544418334961,70.1603775024414 C26.082443237304688,70.1603775024414 34.36544418334961,61.87737274169922 34.36544418334961,51.66037368774414 C34.36544418334961,41.44337463378906 26.082443237304688,33.1606559753418 15.86544418334961,33.1606559753418z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,134,850)",
    opacity: 1,
    style: {
      display: "block"
    }
  }, _g229 || (_g229 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    fillOpacity: 0,
    strokeMiterlimit: 4,
    stroke: "rgb(49,117,209)",
    strokeOpacity: 1,
    strokeWidth: 2,
    d: " M447.7023010253906,-159.16188049316406 C447.7023010253906,-159.16188049316406 265.36700439453125,-111.78800201416016 265.36700439453125,-111.78800201416016"
  }))), _g230 || (_g230 = /*#__PURE__*/React.createElement("g", {
    opacity: 0,
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    fillOpacity: 0,
    strokeMiterlimit: 4,
    stroke: "rgb(49,117,209)",
    strokeOpacity: 1,
    strokeWidth: 2,
    d: " M-8.244000434875488,-277.614990234375 C-8.244000434875488,-277.614990234375 101.1510009765625,-149.07899475097656 101.1510009765625,-149.07899475097656"
  }))), _g231 || (_g231 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    fillOpacity: 0,
    strokeMiterlimit: 4,
    stroke: "rgb(49,117,209)",
    strokeOpacity: 1,
    strokeWidth: 2,
    d: " M106.56392669677734,-150.4142303466797 C106.56392669677734,-150.4142303466797 -25.91183090209961,-285.0242919921875 -25.91183090209961,-285.0242919921875"
  }))), _g232 || (_g232 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    fillOpacity: 0,
    strokeMiterlimit: 4,
    stroke: "rgb(49,117,209)",
    strokeOpacity: 1,
    strokeWidth: 2,
    d: " M127.36083221435547,-188.7248992919922 C127.36083221435547,-188.7248992919922 107.8051986694336,-148.17462158203125 107.8051986694336,-148.17462158203125"
  }))), _g233 || (_g233 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    fillOpacity: 0,
    strokeMiterlimit: 4,
    stroke: "rgb(49,117,209)",
    strokeOpacity: 1,
    strokeWidth: 2,
    d: " M109.6368179321289,-148.59950256347656 C109.6368179321289,-148.59950256347656 266.0224609375,-112.49344635009766 266.0224609375,-112.49344635009766"
  }))), _g234 || (_g234 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "rgb(49,117,209)",
    fillOpacity: 1,
    d: " M110.20681762695312,-155.62850952148438 C114.34881591796875,-155.62850952148438 117.70681762695312,-152.2705078125 117.70681762695312,-148.12850952148438 C117.70681762695312,-143.98651123046875 114.34881591796875,-140.62850952148438 110.20681762695312,-140.62850952148438 C106.06481170654297,-140.62850952148438 102.70681762695312,-143.98651123046875 102.70681762695312,-148.12850952148438 C102.70681762695312,-152.2705078125 106.06481170654297,-155.62850952148438 110.20681762695312,-155.62850952148438z"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgServiceSvg);
export default __webpack_public_path__ + "static/media/service_svg.bf0745522ce1cddaedd99cc1ffd07a27.svg";
export { ForwardRef as ReactComponent };